import {
  forwardRef,
  Fragment,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import {
  DKLabel,
  DKLine,
  DKInput,
  Toggle,
  removeLoader,
  isValidEmail,
  DKStatus,
  DKSpinner,
  DKCheckMark,
  DKTooltipWrapper,
  DKIcon,
  DKExpandableWrapper,
  TOAST_TYPE,
  showToast,
  DKButton,
  DKIcons,
  showAlert,
  showLoader
} from "deskera-ui-library";
import {
  isIndiaCompliance,
  isUSCompliance,
  isValidZipcode,
  removeFirstDecimalFromInput,
  getTenantCountryCode,
  isMYCompliance,
  getCountryPhoneCode,
  scrollToErrorNew,
} from "../../../managers/common/CommonUtil";
import {
  Payment_Details,
  Compensation_Details,
  Details,
  Contact_Details,
  employeeDetailDefaultValues,
  USPaymentMethods,
  AccountTypesUS,
  CompensationPeriodUS,
  readOnlyFieldsForEmployee,
  employeeReadOnlyFieldsPaymentDetail,
  SGPaymentMethods,
  CompensationPeriodMYSG,
  PaymentMethods,
  CONFIG_SECTION
} from "./Employee";
import RouteManager from "../../../managers/RouteManager";
import DataGridUtility from "../../../utility/DataGridUtility";
import Utility, { deepClone, setTabIndex } from "../../../utility/Utility";
import {
  ACCOUNT_NUMBER,
  ARF,
  COLUMN_CODES,
  CONSTANTS,
  COUNTRY_CODE,
  EMPLOYEE_ID_EXIST,
  ERF,
  INPUT_TYPE,
  ROUTING_REGEX,
  TOOLTIP_TEXT,
  DEFAULT_FIELD_VALUES,
  FINANCIAL_MONTHS,
  NONE_OPTION,
  EMAIL_ERROR_CODE
} from "../../../constants/Constant";
import EmployeeListService from "../../../services/EmployeeListService";
import { useSelector } from "react-redux";
import { selectCustomField } from "../../../Redux/Slices/CustomFieldsSlice";
import {
  selectBankDetails,
  selectEmployeeData,
  selectEmployeeTaxDetails,
} from "../../../Redux/Slices/EmployeeListSlice";
import UserService from "../../../services/UserService";
import zeroState from "../../../assets/images/zero-state-default.svg";
import RightPanel from "../RightPanel";
import { IFSC_PATTERN, ROUTING_NUMBER_REGEX, UPI_PATTERN } from "../../../constants/RegexConstants";
import moment from "moment";
import Address, {
  ADDRESS_MODULE,
  addCountrySpecificValidations,
} from "../../common/Address";
import { TENANT, TenantService } from "../../../managers/TenantManagerService";
import { isMobileWebView, isViewportLarge } from "../../../utility/ViewportSizeUtils";
import TenantManager from "../../../managers/TenantManager";
import ic_info_message from "../../../assets/icons/ic_info_gray01.png";
import { selectLocationList } from "../../../Redux/Slices/LocationListSlice";
import AddEditLocation from "../../manage-location/AddLocation";
import MaskInput from "../../../SharedComponents/MaskInput/MaskInput";
import MaskInputUtil from "../../../SharedComponents/MaskInput/MaskInputUtil";
import {CUSTOM_NUMBER_INPUT_MODULES, INPUT_VIEW_DIRECTION} from "../../../components/SequenceNumberFormat/Other";
import CustomNumberFormatInput from "../../../SharedComponents/CustomNumberFormat/CustomNumberFormatInput";
import i18next from "i18next";
import CustomNumberFormatService from "../../../services/CustomNumberFormat";
import { async } from "rxjs";
import { COUNTRY } from "../../../constants/CountryConstant";
import { isUSStateComplianceEnabled } from "../../compliance/us/ConstantsUS";
import PermissionUtils, { ACTION, MODULE } from "../../user-permissions/PermissionUtils";
import ReportService from "../../../services/ReportService";
import { saveAs } from 'file-saver';
import EmployeeConfigService from "../../../services/EmployeeConfigService";
import EmployeeCustomSection from "./EmployeeCustomSection";
import CustomSectionManager from "../../../managers/CustomSectionManager";
import CustomSectionField from "./CustomSectionField";

let timeout;

const EmployeeDetails = forwardRef((props, ref) => {
  const customFieldSectionEnabled = TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED);
  const userId = props.userId ? props.userId : "";
  const [countryCode, setCountryCode] = useState("-1");
  const isAdmin = TenantService.get(TENANT.IS_ADMIN);
  const selfView = userId === TenantService.get(TENANT.USER_ID);

  const initialEmployeeDetailsFormField = EmployeeConfigService.getDefaultFieldsBySection(CONFIG_SECTION.EMPLOYEE_DETAILS);
  const [detailsInitials, setDetailsInitials] = useState(initialEmployeeDetailsFormField);
  let [detailsFormfields, setDetailsFormFields] = useState(detailsInitials);
  
  const initialEmployeeCompensationDetails = EmployeeConfigService.getDefaultFieldsBySection(CONFIG_SECTION.COMPENSATION);
  const [compensationInitials, setCompensationInitials] = useState(initialEmployeeCompensationDetails);
  let [compensationFormfields, setCompensationFormFields] = useState(compensationInitials);
  
  const initialEmployeePaymentDetails = EmployeeConfigService.getDefaultFieldsBySection(CONFIG_SECTION.EMPLOYEE_PAYMENT_DETAILS);
  const [paymentInitials, setPaymentInitials] = useState(deepClone(initialEmployeePaymentDetails));
  let [paymentFormfields, setPaymentFormFields] = useState(paymentInitials);

  let [contactFormfields, setContactFormFields] = useState(null);

  const billingRateFields = EmployeeConfigService.getDefaultFieldsBySection(CONFIG_SECTION.BILLING_RATE);
  const [billingFormFieldsInitials, setBillingFormFieldsInitials] = useState(billingRateFields);
  const [defaultValues, setDefaultValues] = useState(deepClone(employeeDetailDefaultValues));
  const [isTaxesSpinner, setTaxesSpinner] = useState(true);
  const [customFormFields, setCustomFormFields] = useState([]);
  const [customFieldKeys, setCustomKeys] = useState([]);
  const [employeeTaxes, setEmployeeTaxes] = useState([]);

  const customData = useSelector(selectCustomField);
  const employeeDetails = useSelector(selectEmployeeData);
  const employeeTaxDetails = useSelector(selectEmployeeTaxDetails);
  const tenatBankDetails = useSelector(selectBankDetails);
  const [country, setCountry] = useState("");
  const [viewportLarge, setIsViewportLarge] = useState(isViewportLarge());
  const [count, updateCount] = useState(1);
  const [isAutoSaveEnabled, setIsAutoSaveEnabled] = useState(false);
  const [isUSCountry, setUSCountry] = useState(isUSCompliance());
  const [isInviteUserEnabled, setInviteUser] = useState(
    isAdmin && !props.isEdit && isUSCountry
  );
  const [isContactDetailsExpanded, setContactDetailsExpanded] = useState(
    deepClone(!isInviteUserEnabled)
  );
  const [isPaymentDetailsExpanded, setPaymentDetailsExpanded] = useState(
    deepClone(!isInviteUserEnabled)
  );
  const locationData = useSelector(selectLocationList);
  const [allowLocationAdd, setAllowLocationAdd] = useState(false);
  const [employeeId, setEmployeeId] = useState("");
  
  const [valueTDS,setValueTDS]  = useState({
    month:FINANCIAL_MONTHS.find(month=>month.value == moment().format('M')),
    year:moment().format("YYYY")
  });
  const [mask, setMask] = useState(MaskInputUtil.MASK_STATE);
  const maskUnmaskObservable = MaskInputUtil.subscripeToMaskUnmaskObservable(setMask);
  const [employeeIdValid,setEmployeeIdValid] = useState(true)
  const [isDownloadingTDS, setDownloadTDS] = useState(false);
  const [hasPermission, setPermission] = useState(false);

  const [customSections, setCustomSections] = useState(EmployeeConfigService.getNonDefaultFieldSections(1));
  const [terminationDetailSection, setTerminationDetailSection] = useState(null);
  const [hideCompensation, setHideCompensation] = useState(false);
  const [pwRole, setPWRole] = useState(null);

  const [isCompensationDetailsExpanded, setCompensationDetailsExpanded] = useState(true);
  const [isBillingRateExpanded, setBillingRateExpanded] = useState(true);

  useEffect(() => {
    let hasPermission = false;
    if (props.isEdit) {
      if (customFieldSectionEnabled) {
        hasPermission = PermissionUtils.hasAccess(MODULE.EMPLOYEE, [ACTION.EDIT]);
      } else {
        hasPermission = !selfView ? PermissionUtils.hasAccess(MODULE.EMPLOYEE, [ACTION.EDIT]) : true;
      }
    } else {
      hasPermission = PermissionUtils.hasAccess(MODULE.EMPLOYEE, [ACTION.CREATE]);
    }
    setPermission(hasPermission);

    // Handler to call on window resize
    function handleResize() {
      setIsViewportLarge(isViewportLarge());
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    handleResize();

    setTimeout(() => {
      setIsAutoSaveEnabled(customFieldSectionEnabled ? hasPermission : true);
    }, props.isEdit ? 5000 : 2500);

    if (!props.isEdit) {
      updatePaymentMethodForPW();
      setPWRole("user");
    }

    // Remove event listener on cleanup
    return () => {
      window.removeEventListener("resize", handleResize);
      MaskInputUtil.unsubscribe(maskUnmaskObservable);
      clearTimeout(timeout);
    };
  }, []);

  useEffect(() => {
    RouteManager.setPresenter({ props });
    if (!props.isEdit) {
      setCountryCode(TenantService.get(TENANT.COUNTRY_CODE));
    }
    buildForm();
    updatePropsValue();
  }, []);

  useEffect(() => {
    buildForm();
    updatePropsValue();
  }, [isInviteUserEnabled]);

  useEffect(() => {
    if (
      !Utility.isEmpty(userId) &&
      !Utility.isEmpty(employeeDetails) &&
      employeeDetails.user
    ) {
      updateDefaultValue();
      if (employeeDetails.user.address.country) {
        setCountryCode(employeeDetails.user.address.country);
      } else {
        setCountryCode(TenantService.get(TENANT.COUNTRY_CODE));
      }

      if (employeeDetails.user.terminationStage === "termination_initiated" || employeeDetails.user.terminationStage === "terminated") {
        setTerminationDetailSection(EmployeeConfigService.getTerminationDetailSection(employeeDetails.user.terminationDetails))
      }

      if (props.isEdit && Utility.isEmpty(defaultValues["paymentMethod"])) {
        updatePaymentMethodForPW();
      }

      if (customFieldSectionEnabled) {
        setHideCompensation(employeeDetails.user.hideCompensation);
        setPWRole(!selfView ? employeeDetails.user.pwRoleKey : "self");
      }
    }
  }, [employeeDetails]);

  useEffect(() => {
    if (!isAdmin) {
        setTabIndex([ERF.ADD_EMPLOYEE]);
    } else if (isAdmin && props.isEdit) {
        setTabIndex([ARF.ADD_EMPLOYEE]);
    }
  }, [detailsFormfields, compensationFormfields, paymentFormfields]);

  useEffect(() => {
    let tenantData = TenantService.getData();
    setCountry(tenantData[TENANT.COUNTRY_CODE]);
    const { tenant } = TenantManager.getPeopleTenantData();
    switch (tenantData[TENANT.COUNTRY_CODE]) {
      case COUNTRY_CODE.US:
        let paymentDetails = paymentInitials;
        const alteredOptionsUS = [
          { columnCode: "paymentMethod", options: USPaymentMethods, defaultOptions: USPaymentMethods },
          {columnCode: "accountType", options: AccountTypesUS, defaultOptions: AccountTypesUS},
          {columnCode: "ifsc", uiVisible: false, required : false},
          {columnCode:"routingNumber", required: true, errMsg: "Branch Code is required"},
          {columnCode: "bank", uiVisible: false, required : false},
        ];
        paymentDetails = EmployeeListService.getAlteredConfigDetails(
          paymentDetails,
          alteredOptionsUS,
          false,
          {},{}
        );
        setPaymentInitials(paymentDetails);
        break;
        case COUNTRY.SG:
        let paymentDetailsSG = paymentInitials;
        const bankAccounts = EmployeeListService.getBankAccounts(tenatBankDetails);
        const alteredOptionsSG = [
          { columnCode: "paymentMethod", options: SGPaymentMethods, defaultOptions: SGPaymentMethods },
          {columnCode: "bank", options: bankAccounts, defaultOptions: bankAccounts},
          {columnCode: "ifsc", uiVisible: false, required : false},
          {columnCode:"routingNumber", name: "Branch Code", required: true, errMsg: "Branch Code is required"},
          {columnCode: "accountType", uiVisible: false, required : false},
          { columnCode: "accountNumber", name : "Account Number" }
        ];
        paymentDetailsSG = EmployeeListService.getAlteredConfigDetails(paymentDetailsSG, alteredOptionsSG, false, {}, {});
        setPaymentInitials(paymentDetailsSG);
        break;
        case COUNTRY.MY:
        let paymentDetailsMY = paymentInitials;
        const bankAccountsMY = EmployeeListService.getBankAccounts(tenatBankDetails);
        const alteredOptionsMY = [
          { columnCode: "paymentMethod", options: USPaymentMethods, defaultOptions: USPaymentMethods },
          {columnCode: "bank", options: bankAccountsMY, defaultOptions: bankAccountsMY},
          {columnCode: "ifsc", uiVisible: false, required : false},
          {columnCode:"routingNumber", name: "Branch Code", required: true, errMsg: "Branch Code is required"},
          {columnCode: "accountType", uiVisible: false, required : false},
          { columnCode: "accountNumber", name : "Account Number" }
        ];
        paymentDetailsMY = EmployeeListService.getAlteredConfigDetails(paymentDetailsMY, alteredOptionsMY, false, {}, {});
        setPaymentInitials(paymentDetailsMY);
        break;
      case COUNTRY.IN:
        let paymentDetailsIN = paymentInitials;
        const alteredOptionsIN = [
          { columnCode: "paymentMethod", options: PaymentMethods, defaultOptions: PaymentMethods },
          {columnCode: "bank", uiVisible: false, required : false}
        ];
        paymentDetailsIN = EmployeeListService.getAlteredConfigDetails(paymentDetailsIN, alteredOptionsIN, false, {}, {});
        setPaymentInitials(paymentDetailsIN);
      default:
        break;
    }

    updatePropsValue();
  }, [
    detailsFormfields,
    contactFormfields,
    compensationFormfields,
    paymentFormfields,
    customFormFields,
    paymentInitials,
    tenatBankDetails,
    billingFormFieldsInitials,
    customSections
  ]);

  useEffect(() => {
    if (isAutoSaveEnabled) {
      updatePropsValue(true);
    }
  }, [
    detailsFormfields,
    contactFormfields,
    compensationFormfields,
    paymentFormfields,
    customFormFields,
    paymentInitials,
    billingFormFieldsInitials,
    customSections
  ]);

  useEffect(() => {
      if (!Utility.isEmpty(employeeTaxDetails) && Array.isArray(employeeTaxDetails)) {
          let processedTaxes = getProcessedTaxData(employeeTaxDetails);
          if (employeeDetails?.user) {
              processedTaxes = processedTaxes.map((t) => {
                  const tax = { ...t };
                  if (tax.name === "ESI") {
                      tax.applicable = employeeDetails?.user?.compliance?.esiApplicable;
                  }
    
                  return tax;
              });
          }
          setTaxesSpinner(false);
          setEmployeeTaxes(processedTaxes);
      }
  }, [employeeTaxDetails, employeeDetails]);

  useEffect(() => {
    if (
      !Utility.isEmpty(customData) &&
      !Utility.isEmpty(customData.customFields)
    ) {
      const filterCustomFields = customData.customFields.filter(field=>field.isActive)
      const processedValue = EmployeeListService.createCustomFieldArray(
        filterCustomFields,
        defaultValues,
        customFieldKeys
      );
      setCustomFormFields(processedValue);

      if (!Utility.isEmpty(employeeDetails.user)) {
        EmployeeListService.setCustomFieldValues(defaultValues, employeeDetails.user, customData.customFields);
      }
    }
  }, [customData]);

  useEffect(() => {
    if (locationData !="loading") {
      const tenantDetails = TenantManager.getTenantDetails();
      const additionalSettings = tenantDetails
        ? tenantDetails.additionalSettings
        : "";
      const locationSettings = additionalSettings
        ? additionalSettings?.["LOCATION"]
        : {};
      const isLocationEnabled = locationSettings?.trackLocation || false;
        let locationOptions = locationData && locationData.map((x) => {
          return {
            id: x.id,
            name: x.label,
          };
        });
        const index = detailsInitials.findIndex(
          (field) => field.columnCode === COLUMN_CODES.LOCATION_VALUE
        );
        if (index != -1) {
          const buttonsConfig = {
            title: `+ Add a location`,
            onClick: () => {
              onAddLocation();
            },
            className: "bg-app text-white",
          };
          detailsInitials[index].options = locationOptions;
          detailsInitials[index].defaultOptions = locationOptions;
          detailsInitials[index].uiVisible = isLocationEnabled;
          detailsInitials[index].hidden = !isLocationEnabled;
          detailsInitials[index].name = locationSettings?.locationLabel || "";
          detailsInitials[index].button = buttonsConfig;
          detailsInitials[index].readOnly = !isAdmin && !hasPermission
        }

        updateLocationValueInDefaultValue(locationOptions);
        buildForm();
    }
  }, [locationData, employeeDetails]);

  useEffect(() => {
    updatePropsValue()
  }, [employeeIdValid])
  const updateLocationValueInDefaultValue = (options) => {
    if (
      !Utility.isEmpty(userId) &&
      !Utility.isEmpty(employeeDetails) &&
      employeeDetails.user
    ) {
      const userDetails = employeeDetails.user;
      const locationValue = userDetails?.locationValue;
      defaultValues[COLUMN_CODES.LOCATION_VALUE] =
        EmployeeListService.getValueObjectFromDropdown(
          locationValue,
          options,
          "id"
        );
    }
  }

  useEffect(() => {
    if (customFieldSectionEnabled) {
      const index = detailsInitials.findIndex(
        (field) => field.columnCode === "reportingManagerName"
      );

      if (index !== -1) {
        detailsInitials[index].required = true;

        if (!Utility.isEmpty(userId) && !Utility.isEmpty(employeeDetails?.user?.reportingManagerName)) {
          defaultValues["reportingManagerName"] = employeeDetails.user.reportingManagerName;
          buildForm();
        }
      }
    } else {
      const index = detailsInitials.findIndex(
        (field) => field.columnCode === "reportingManagerId"
      );
      if (index !== -1 && Array.isArray(props.reportingManagerOptions)) {
        detailsInitials[index].options = props.reportingManagerOptions;
        detailsInitials[index].defaultOptions = props.reportingManagerOptions;
  
        if (!Utility.isEmpty(userId) && !Utility.isEmpty(employeeDetails?.user?.reportingManagerId)) {
          defaultValues["reportingManagerId"] = EmployeeListService.getValueObjectFromDropdown(employeeDetails.user.reportingManagerId, props.reportingManagerOptions, "id");
        } else {
          defaultValues["reportingManagerId"] = NONE_OPTION
        }

        buildForm();
      }
    }
  }, [props.reportingManagerOptions, employeeDetails])

  useImperativeHandle(ref, () => ({
    hightlightInvalidFields(skipStepValidation) {
      let totalColumnConfig = [
        detailsFormfields,
        compensationFormfields,
        paymentFormfields,
        customFormFields,
        billingFormFieldsInitials
      ];

      const invalidFields = [];
      for (let i = 0; i < totalColumnConfig.length; i++) {
        let columnConfig = totalColumnConfig[i];
        for (let item = 0; item < columnConfig?.length; item++) {
          let individualColumn = columnConfig[item];
          const params = defaultValues;
          if (
            individualColumn &&
            defaultValues &&
            ((individualColumn.required &&
              Utility.isEmpty(defaultValues[individualColumn.columnCode])) ||
              individualColumn.hasError)
          ) {
            individualColumn.hasError = true;
            invalidFields.push(individualColumn.columnCode);
          } else {
            switch (individualColumn.columnCode) {
              case COLUMN_CODES.CTC:
                let ctc = params[COLUMN_CODES.CTC];
                if (customFieldSectionEnabled) {
                  if (isNaN(parseFloat(ctc))) {
                    individualColumn.hasError = true;
                    invalidFields.push(individualColumn.columnCode);
                  }
                } else {
                  if (typeof parseFloat(ctc) === "number" && Utility.isEmpty(parseFloat(ctc))) {
                    individualColumn.hasError = true;
                    invalidFields.push(individualColumn.columnCode);
                  }
                }
                break;
              case COLUMN_CODES.DEFAULT_COMPENSATION:
                let defaultCompensation =
                  params[COLUMN_CODES.DEFAULT_COMPENSATION];
                if (
                  typeof parseFloat(defaultCompensation) === "number" &&
                  Utility.isEmpty(parseFloat(defaultCompensation))
                ) {
                  individualColumn.hasError = true;
                  invalidFields.push(individualColumn.columnCode);
                }
                break;
              case COLUMN_CODES.EMPLOYEEID:
                if (props.isDuplicateEmpId) {
                    individualColumn.hasError = true;
                    individualColumn.errMsg = "Employee ID already exist";
                    invalidFields.push(individualColumn.columnCode);
                }
                break;
                case COLUMN_CODES.DATE_OF_CONFIRMATION:
                    let invalid = checkValidation(individualColumn);
                    if(invalid) {
                        individualColumn.hasError = true;
                        individualColumn.errMsg = "DOC cannot be less than DOJ";
                        invalidFields.push(individualColumn.columnCode);
                    } else {
                        individualColumn.hasError = false;
                    }
                    break;
                case COLUMN_CODES.DATE_OF_BIRTH:
                    let invalidDob = checkValidation(individualColumn);
                    if(invalidDob) {
                        individualColumn.hasError = true;
                        individualColumn.errMsg = `DOB cannot be greater than or equal to DOJ`;
                        invalidFields.push(individualColumn.columnCode);
                    } else {
                        individualColumn.hasError = false;
                    }
            }
          }
        }
        if(invalidFields.length > 0) {
          expandeInvalidSection(invalidFields);
        }
      }

      if (!skipStepValidation && Array.isArray(customSections)) {
        const customSectionsToUpdate = CustomSectionManager.validateCustomSections(customSections);
        customSectionsToUpdate.forEach((section) => {
          if (Array.isArray(section.fields)) {
            section.fields.forEach((field) => {
              if (field.hasError) {
                invalidFields.push(field.id);
              }
            });
          }
        });

        setCustomSections(customSectionsToUpdate);

        if(invalidFields.length > 0) {
          expandeInvalidSection(invalidFields);
        }
      }

      contactFormfields.forEach((field) => {
        const error = hasError(field, field.value);
        field.invalid = error.invalid;
        field.errorMsg = error.errorMsg;
        if (field.invalid) {
          field.invalid = true;
          invalidFields.push(field.id);
        }
      });

      if(invalidFields.length > 0) {
        expandeInvalidSection(invalidFields);
      }

      let columnConfig = deepClone(customFormFields);
      setCustomFormFields(columnConfig);
    },

    hightlightInvalidEmployeeId() {
        const columnConfig = deepClone(detailsFormfields);
        for (let item = 0; item < columnConfig?.length; item++) {
            const individualColumn = columnConfig[item];
            switch (individualColumn.columnCode) {
                case COLUMN_CODES.EMPLOYEEID:
                    if (props.isDuplicateEmpId) {
                        individualColumn.hasError = true;
                        individualColumn.errMsg = "Employee ID already exist";
                    }
                    break;
            }
        }

        setDetailsFormFields(columnConfig);
    }
  }));

  const containAny = (arr1, arr2) => {
    const set1 = new Set(arr1);
    return arr2.some(word => set1.has(word));
  }

  const containInCustomSection = (sectionName, invalidFields) => {
    const section = EmployeeConfigService.getNonDefaultSectionsByName(customSections, sectionName);
    if (Array.isArray(section?.fields)) {
      return containAny(section.fields.map(f => f.id), invalidFields);
    }

    return false;
  }

  const expandeInvalidSection = (invalidFields) => {
    if (containAny(Contact_Details, invalidFields) || containInCustomSection(CONFIG_SECTION.ADDRESS, invalidFields)) {
      setContactDetailsExpanded(true);
    }

    if (containAny(Compensation_Details, invalidFields) || containInCustomSection(CONFIG_SECTION.COMPENSATION, invalidFields)) {
      setCompensationDetailsExpanded(true);
    }

    if (containAny(Payment_Details, invalidFields) || containInCustomSection(CONFIG_SECTION.EMPLOYEE_PAYMENT_DETAILS, invalidFields)) {
      setPaymentDetailsExpanded(true);
    }

    let isUpdateRequired = false;
    let customSectionsToUpdate = [...customSections];
    customSectionsToUpdate.forEach((section) => {
      if (!section.defaultSection && Array.isArray(section.fields)) {
        section.fields.forEach(field => {
          if (invalidFields.includes(field.id)) {
              section.isExpanded = true;
              isUpdateRequired = true;
          }
        });
      }
    });

    if (isUpdateRequired) {
      setCustomSections(customSectionsToUpdate);
    }

    setTimeout(() => {
      scrollToErrorNew(invalidFields);
    }, 500);
  }

  const updatePaymentMethodForPW = () => {
    if (customFieldSectionEnabled) {
      const idx = paymentFormfields.findIndex(f => f.columnCode === "paymentMethod");
      if (idx !== -1) {
        setTimeout(() => {
          onChange({ id: "cash", name: "Cash" }, idx, paymentFormfields[idx]);
        }, 500);
      }
    }
  }

    const checkValidation = (column) => {
        let invalid = false;
        let errorMessage = false
        const validation = column.validation;
        validation.forEach((v) => {
            switch (v) {
                case "greaterThan":
                    let doj = defaultValues[column.greaterThanField[0]];
                    let doc = defaultValues["dateOfConfirmation"];

                    if (!Utility.isEmpty(doj) && !Utility.isEmpty(doc)) {
                        doj = moment(defaultValues[column.greaterThanField[0]]);
                        doc = moment(defaultValues["dateOfConfirmation"]);
                        invalid = doj.diff(doc) > 0;
                    } else {
                        invalid = false;
                    }
                    break;
                case "lessThan":

                    let doj1 = moment(defaultValues[column.lessThanField[0]]);
                    let dob = moment(defaultValues["dateOfBirth"]);
                    if (!Utility.isEmpty(doj1) && moment(dob).isSameOrAfter(doj1)) {
                        invalid = true;
                    } else {
                        invalid = false;
                    }
                    break;
            }
        });
        return invalid;
    }

  const hasError = (field, value) => {
    let error = {
      invalid: false,
      errorMsg: null,
    };

    const validation = field.validation;

    if (validation && validation.length !== 0) {
      validation.forEach((validation) => {
        switch (validation[0]) {
          case "required":
            if (
              value === null ||
              value === undefined ||
              String(value).trim() === ""
            ) {
              error.invalid = true;
            }
            break;
          case "pattern":
            if (value && !new RegExp(validation[1]).test(value)) {
              error.invalid = true;
              error.errorMsg = "Invalid " + field.title;
            }
            break;
        }
      });
    }

    return error;
  };

  const buildForm = () => {
    putAdditionalFields().then(() => {
      const tenantCountryCode = getTenantCountryCode();
      const detailInitialFields = updateDetailsFieldTenantWise(detailsInitials, tenantCountryCode);
      detailsFormfields = detailInitialFields.filter((x) => x.uiVisible);
      let employeeDetailFields = DataGridUtility.getFormElements(
        detailsFormfields,
        defaultValues,
        true
      );
      let isAdmin  = TenantService.get(TENANT.IS_ADMIN)
      if (defaultValues.passportNumber && defaultValues.passportNumber != "") {
        let passportCountryIndex = employeeDetailFields.findIndex(
          (x) => x.id === COLUMN_CODES.PASSPORT_COUNTRY
        );
        if (passportCountryIndex != -1) {
          employeeDetailFields[passportCountryIndex].required = true;
        }
      }
      if(!isAdmin && hasPermission) {
        employeeDetailFields.forEach(field=>{
          if( readOnlyFieldsForEmployee.findIndex(f=>f===field.columnCode) !==-1 ) {
            field.readOnly = true;
          }
        })
      }

      if (isAdmin && selfView || !isUSCompliance()) {
        employeeDetailFields = employeeDetailFields.filter((field) => {
            return field.columnCode !== "inviteUserToFillInfo";
        });
      }

      setDetailsFormFields(employeeDetailFields);

      compensationFormfields = compensationInitials.filter((x) => x.uiVisible);
      if (!isIndiaCompliance()) {
        compensationFormfields = updateFieldToBasicSalary(
          compensationFormfields
        );
        compensationFormfields = updateCopensationFields(
          compensationFormfields
        );
      }
      if(!Utility.isEmpty(defaultValues.effectiveDate) && defaultValues.effectiveDate.toDateString() === "Invalid Date") {
        defaultValues.effectiveDate = CONSTANTS.EMPTY_STRING
      }
      let employeeCompensationFields = DataGridUtility.getFormElements(
        compensationFormfields,
        defaultValues,
        true
      );
      setCompensationFormFields(employeeCompensationFields);
      buildPaymentDetails();
    });
  };

  const buildPaymentDetails = () => {
    const tenantCountryCode = getTenantCountryCode();
    updateDetailsFieldTenantWise(paymentInitials, tenantCountryCode);
    paymentFormfields = paymentInitials.filter((x) => x.uiVisible);
    let employeePaymentFields = DataGridUtility.getPaymentFormElements(
      paymentFormfields,
      defaultValues,
      true,
      isInviteUserEnabled
    );
    if(!isAdmin) {
      if ((!isUSStateComplianceEnabled(TenantService.get(TENANT.STATE_CODE)) && !hasPermission) || customFieldSectionEnabled) {
        employeePaymentFields.forEach(field=>{
          if( employeeReadOnlyFieldsPaymentDetail.findIndex(f=>f===field.columnCode) !==-1 ) {
            field.readOnly = true;
  
          }
        })
      }
    }
    setPaymentFormFields(employeePaymentFields);
  }

  const updateFieldToBasicSalary = (formfields) => {
    if (customFieldSectionEnabled) {
      const field = formfields.find((x) => x.columnCode === COLUMN_CODES.CTC);
      if (field) {
        const name = defaultValues["isEffectiveSalary"] ? i18next.t("DEFAULT_PW_BASIC_SALARY") : i18next.t("PW_BASIC_SALARY");
        field["name"] = name;
        field["errMsg"] = `Enter a valid ${name}`;
      }
    } else {
      const field = formfields.find((x) => x.name === COLUMN_CODES.CTC);
      if (field) {
        field["name"] = i18next.t("BASIC_SALARY");
        field["errMsg"] = `Enter a valid ${i18next.t("BASIC_SALARY")}`;
      }
    }
    return formfields;
  };

  const updateCopensationFields = (formfields) => {
    formfields.forEach((field) => {
      switch (field.columnCode) {
        case COLUMN_CODES.PERIOD:
        case COLUMN_CODES.EFFECTIVE_PERIOD:
          switch(getTenantCountryCode()) {
            case COUNTRY.US:
              field.options = CompensationPeriodUS;
              field.defaultOptions = CompensationPeriodUS;
              break
            default:
              field.options = CompensationPeriodMYSG;
              field.defaultOptions = CompensationPeriodMYSG;
              break
          }
          break;
        case COLUMN_CODES.CTC:
          if (defaultValues[COLUMN_CODES.CTC] === "-1") {
            field.readOnly = true;
          }
          break;
      }
    });
    return formfields;
  };

  const updateDetailsFieldTenantWise = (formfields, countryCode) => {
  switch (countryCode) {
    case COUNTRY_CODE.US:
      let updatedConfigUS = [
        { columnCode: COLUMN_CODES.GENDER, uiVisible: false, hidden: true },
        { columnCode: COLUMN_CODES.MARITAL_STATUS, uiVisible: false, hidden: true },
        { columnCode: COLUMN_CODES.PASSPORT_COUNTRY, uiVisible: false, hidden: true },
        { columnCode: COLUMN_CODES.PASSPORT_NUMBER, uiVisible: false, hidden: true },
        { columnCode: COLUMN_CODES.DATE_OF_CONFIRMATION, uiVisible: false, hidden: true },
        { columnCode: COLUMN_CODES.DATE_OF_JOINING, name: "Date of Joining", errMsg: "Date of Joining is required" },
        { columnCode: COLUMN_CODES.INVITE_USER, uiVisible: isAdmin, hidden: !isAdmin, hasTooltip: !isInviteUserEnabled },
        { columnCode: COLUMN_CODES.ALIAS_NAME, uiVisible: false, hidden: true },
        { columnCode: COLUMN_CODES.DATE_OF_BIRTH, required: !isInviteUserEnabled },
        { columnCode: COLUMN_CODES.EMAIL_ID, tooltipText : isAdmin ? TOOLTIP_TEXT.EMAIL_ID:TOOLTIP_TEXT.EMPTY_STRING },
        { columnCode: COLUMN_CODES.CONTACT, required: false },
        { columnCode: COLUMN_CODES.IFSC_CODE, required: false, uiVisible: false },
      ];
      formfields = EmployeeListService.getAlteredConfigDetails(
        formfields,
        updatedConfigUS,
        false,
        {},
        {}
      );
      return formfields;
    case COUNTRY_CODE.SINGAPORE:
      let updatedConfigSG = [
        { columnCode: COLUMN_CODES.CONTACT, required: false },
      ];
      formfields = EmployeeListService.getAlteredConfigDetails(
        formfields,
        updatedConfigSG,
        false,
        {},
        {}
      );
      return formfields;
      case COUNTRY_CODE.MY:
      let updatedConfigMY = [
        { columnCode: COLUMN_CODES.CONTACT, required: false },
      ];
      formfields = EmployeeListService.getAlteredConfigDetails(
        formfields,
        updatedConfigMY,
        false,
        {},
        {}
      );
      return formfields;
      case "IN":
        let alteredConfigIN = []
        let isIfscVisible = (defaultValues['paymentMethod'] && defaultValues['paymentMethod'].id === "directDeposit") || Utility.isEmpty(defaultValues['paymentMethod'])
        alteredConfigIN.push({ columnCode: "ifsc", required: isIfscVisible, uiVisible: isIfscVisible, name: "IFSC Code" });
        formfields = EmployeeListService.getAlteredConfigDetails(
          formfields,
          alteredConfigIN,
          false,
          {},
          {}
        );
        return formfields;
    default:
      const updatedConfigDefault = [
          { columnCode: COLUMN_CODES.BANK, required: false, uiVisible: false },
          { columnCode: COLUMN_CODES.IFSC_CODE, required: false, uiVisible: false },
      ];
      formfields = EmployeeListService.getAlteredConfigDetails(formfields, updatedConfigDefault, false, {}, {});
      return formfields;
    }
   };

  const updateDefaultValue = () => {
    let userDetails = employeeDetails.user;
    let customFieldData =
      customData && customData.customFields ? customData.customFields : [];
      let bankAccounts = tenatBankDetails?.banksDetails ? EmployeeListService.getBankAccounts(tenatBankDetails) : [];
    EmployeeListService.assignEmployeeDetails(
      defaultValues,
      userDetails,
      customFieldData,
      bankAccounts
    );
    let paymentMethod = defaultValues["paymentMethod"];
    let isInviteFlowEnabled = isUSCountry && isAdmin && !selfView && defaultValues["inviteUserToFillInfo"];
    updateColumConfigForPaymentMethod(paymentMethod, isInviteFlowEnabled);
    enableDisabledEffectiveSalaryFields(defaultValues["isEffectiveSalary"]);
    removeLoader();
    buildForm();
    setInviteUser(isInviteFlowEnabled);
    setContactDetailsExpanded(!isInviteFlowEnabled);
    setPaymentDetailsExpanded(!isInviteFlowEnabled);

    const customSectionsToUpdate = CustomSectionManager.setCustomSectionFieldValues(customSections, userDetails["customSectionFields"]);
    defaultValues["customSectionFields"] = CustomSectionManager.getCustomSectionFields(customSectionsToUpdate);
    setCustomSections(customSectionsToUpdate);
  };

  const putAdditionalFields = () => {
    updateFieldOptions();
    return Promise.resolve();
  };

  const updateFieldOptions = () => {
    //Do not remove this message
  };

  const getProcessedTaxData = (taxDetails) => {
    let taxes = [];
    taxDetails &&
      taxDetails.forEach((element) => {
        taxes = element.taxes;
      });
    return taxes;
  };

  const setEffectiveToggle = () => {
    defaultValues["isEffectiveSalary"] = !defaultValues["isEffectiveSalary"];
    defaultValues[COLUMN_CODES.EFFECTIVE_PERIOD] = defaultValues[COLUMN_CODES.PERIOD]
    enableDisabledEffectiveSalaryFields(defaultValues["isEffectiveSalary"]);
    buildForm();
  };

  const enableDisabledEffectiveSalaryFields = (isEffectiveSalaryEnabled) => {
    let columnConfig = compensationInitials;
    const effectiveDate = defaultValues['effectiveDate'];
    columnConfig.forEach((column) => {
      switch (column.id) {
        case "effectiveDate":
          if (isEffectiveSalaryEnabled) {
            column.required = true;
            column.uiVisible = true;
          } else {
            column.required = false;
            column.uiVisible = false;
            column.hasError = false;
          }
          break;
        case "defaultCompensation":
          if (isEffectiveSalaryEnabled) {
            const name = customFieldSectionEnabled ? i18next.t("PW_BASIC_SALARY") : i18next.t("BASIC_SALARY");
            column.required = true;
            column.uiVisible = true;
            column.name = name;
            column.errMsg = `Enter a valid ${name}`;
          } else {
            column.required = false;
            column.uiVisible = false;
            column.hasError = false;
            column.name = "Default";
            column.errMsg = `Enter a valid ${column.name}`;
          }
          break;
        case "effectivePeriod":
          if (isEffectiveSalaryEnabled) {
            column.required = true;
            column.uiVisible = true;
            column.readOnly = true;
          } else {
            column.required = false;
            column.uiVisible = false;
            column.hasError = false;
            column.readOnly = true;
          }
          break;
        case "ctc":
          if (isEffectiveSalaryEnabled) {
            column.required = true;
            column.readOnly = moment().isSameOrAfter(effectiveDate)
            column.name = "Default";
            column.errMsg = `Enter a valid ${column.name}`;
          } else {
            column.name = i18next.t("BASIC_SALARY");
            column.required = true;
            column.readOnly = false;
            column.errMsg = `Enter a valid ${i18next.t("BASIC_SALARY")}`;
          }
          break;
        case 'period':
          if (isEffectiveSalaryEnabled) {
            column.readOnly = moment().isSameOrAfter(effectiveDate)
          } else {
            column.readOnly = false;
          }
          break;
        case 'hourlyWageDefaultHrs':
          if (isEffectiveSalaryEnabled && isIndiaCompliance() && defaultValues.period?.id === "hourly") {
            column.readOnly = moment().isSameOrAfter(effectiveDate)
            column.uiVisible = true;
            column.required = true;
          } else if (!isEffectiveSalaryEnabled && isIndiaCompliance() && defaultValues.period?.id === "hourly") {
            var alteredConfig = [];
            alteredConfig.push({
              columnCode: COLUMN_CODES.DEFAULT_HRS,
              readOnly: false, required: true, uiVisible: true
            },
              {
                columnCode: COLUMN_CODES.EMPLOYMENT_TYPE,
                width: 25,
              })
            EmployeeListService.getAlteredConfigDetails(columnConfig, alteredConfig, false)
          } else {
            column.readOnly = false;
            column.uiVisible = false;
          }
          break;
        case 'effectiveDefaultHrs':
          if (isEffectiveSalaryEnabled && defaultValues.effectivePeriod?.id === "hourly" && isIndiaCompliance()) {
            var alteredConfig = [];
            alteredConfig.push(
              { columnCode: COLUMN_CODES.EFFECTIVE_DEFAULT_HRS, uiVisible: true, required: true },
              { columnCode: COLUMN_CODES.EMPLOYMENT_TYPE, width: 25 }
            )
            EmployeeListService.getAlteredConfigDetails(columnConfig, alteredConfig, false)
          }else{
            column.uiVisible = false;
            column.required = false;
          }
          break;
        case 'employeeType':
          if (isEffectiveSalaryEnabled && defaultValues.effectivePeriod?.id === "hourly" && isIndiaCompliance()) {
            var alteredConfig = [];
            alteredConfig.push(
              { columnCode: COLUMN_CODES.EMPLOYMENT_TYPE, width: 25 }
            )
            EmployeeListService.getAlteredConfigDetails(columnConfig, alteredConfig, false)
          } else {
            var alteredConfig = [];
            alteredConfig.push(
              { columnCode: COLUMN_CODES.EMPLOYMENT_TYPE, width: 50 }
            )
            EmployeeListService.getAlteredConfigDetails(columnConfig, alteredConfig, false)
          }
          break;
      }
    });
  };

  const updateColumnStatus = (object, columnConfig, value) => {
    switch (object.id) {
      case COLUMN_CODES.EFFECTIVE_DATE:
        const isEnabled = defaultValues["isEffectiveSalary"];
        const effectiveDate = value;
        if (effectiveDate != "" && isEnabled) {
          if (moment().isSameOrAfter(effectiveDate)) {
            //Today's date same or of future
            columnConfig.forEach((element) => {
              switch (element.id) {
                case COLUMN_CODES.CTC:
                  element.readOnly = true;
                  element.required = false;
                  element.hasError = false;
                  break;
                case COLUMN_CODES.PERIOD:
                  element.readOnly = true;
                  element.required = false;
                  element.hasError = false;
                  break;
                case COLUMN_CODES.DEFAULT_HRS:
                  if (isIndiaCompliance() && defaultValues.period?.id === "hourly") {
                    element.readOnly = true;
                    element.hasError = false;
                    element.required = false;
                    element.uiVisible = true;
                  } else {
                    element.uiVisible = false;
                  }
                  break;
                case COLUMN_CODES.EFFECTIVE_DEFAULT_HRS:
                  if (isIndiaCompliance() && defaultValues.effectivePeriod?.id === "hourly") {
                    element.readOnly = false;
                    element.hasError = false;
                    element.required = true;
                    element.uiVisible = true;
                  } else {
                    element.uiVisible = false;
                  }
                  break;
              }
            });
          } else {
            columnConfig.forEach((element) => {
              switch (element.id) {
                case COLUMN_CODES.CTC:
                  element.readOnly = false;
                  element.required = true;
                  break;
                case COLUMN_CODES.PERIOD:
                  element.readOnly = false;
                  element.required = true;
                  break;
                case COLUMN_CODES.DEFAULT_HRS:
                  if (isIndiaCompliance() && defaultValues.period?.id === "hourly") {
                    element.readOnly = false;
                    element.uiVisible = true;
                    element.required = true;
                  } else {
                    element.uiVisible = false;
                    element.required = false;
                  }
                  break;
              }
            });
          }
        }
        break;
      case COLUMN_CODES.PERIOD:
        var alteredConfig = [];
        if (value.id === "hourly" && isIndiaCompliance()) {
          const defaultHrsIndex = columnConfig.findIndex(i => i.id === COLUMN_CODES.DEFAULT_HRS)
          if (defaultHrsIndex === -1) {
            const idx = compensationInitials.findIndex(c => c.id === COLUMN_CODES.PERIOD)
            if (idx !== -1) {
              const defaultHr = compensationInitials.find(c => c.columnCode === COLUMN_CODES.DEFAULT_HRS)
              if (!Utility.isEmptyObject(defaultHr)) {
                columnConfig.splice(idx + 1, 0, defaultHr)
              }
            }
          }
          alteredConfig.push({
            columnCode: COLUMN_CODES.DEFAULT_HRS,
            readOnly: false, required: true, uiVisible: true, hidden: false,
          })
          if (!defaultValues["isEffectiveSalary"]) {
            alteredConfig.push(
              {
                columnCode: COLUMN_CODES.EMPLOYMENT_TYPE, width: 25,
              })
          }
        } else {
          alteredConfig.push({
            columnCode: COLUMN_CODES.DEFAULT_HRS,
            required: false, uiVisible: false, hidden: true, hasError: false
          })
          if (!defaultValues["isEffectiveSalary"]) {
            alteredConfig.push(
              {
                columnCode: COLUMN_CODES.EMPLOYMENT_TYPE, width: 50,
              })
          }
        } 
        
    /// Case for Effective period
      case COLUMN_CODES.EFFECTIVE_PERIOD:
        if (value.id === "hourly" && isIndiaCompliance()) {
          const effHrsIndex = columnConfig.findIndex(i => i.id === COLUMN_CODES.EFFECTIVE_DEFAULT_HRS)
          if (effHrsIndex === -1) {
            const idx = compensationInitials.findIndex(c => c.id === COLUMN_CODES.EFFECTIVE_PERIOD)
            if (idx !== -1) {
              const defaultHr = compensationInitials.find(c => c.columnCode === COLUMN_CODES.EFFECTIVE_DEFAULT_HRS)
              if (!Utility.isEmptyObject(defaultHr)) {
                columnConfig.splice(idx + 1, 0, defaultHr)
              }
            }
          } 
          alteredConfig.push({
            columnCode: COLUMN_CODES.EFFECTIVE_DEFAULT_HRS,
            readOnly: false, uiVisible: defaultValues['isEffectiveSalary'], hidden: !defaultValues['isEffectiveSalary'],
            name: "Default hours/day",
            required: defaultValues['isEffectiveSalary']
            },
            {
              columnCode: COLUMN_CODES.EMPLOYMENT_TYPE, width: 25,
            },
            {
              columnCode: COLUMN_CODES.EFFECTIVE_PERIOD, readOnly:true,
              required: defaultValues['isEffectiveSalary']
            }
          )
        } else {
          alteredConfig.push({
            columnCode: COLUMN_CODES.EFFECTIVE_DEFAULT_HRS,
            required: false, uiVisible: false, hidden: true,
          },
            { columnCode: COLUMN_CODES.EMPLOYMENT_TYPE, width: 50 })
        }
        EmployeeListService.getAlteredConfigDetails(columnConfig, alteredConfig, false)
    }
  };

  const scrollToBottom = () => {
    setTimeout(() => {
      const holder = document.getElementById("dk-form-popup-window");
      if (holder) {
        holder.scrollTop = holder.offsetHeight;
      }
    }, 10);
  };

  const onChange = (value, index, object, fieldName) => {
    if (value && value === " ") {
      value = value.trim();
    }
    if (Details.some((x) => x === object.id)) {
      let columnConfig = deepClone(detailsFormfields);
      columnConfig = updateLocationButtonConfig(columnConfig);
      if (Utility.isEmpty(value) && object.required) {
        columnConfig[index].hasError = true;
      } else {
        columnConfig[index].hasError = false;
      }
      switch (object.columnCode) {
        case "emailId":
          columnConfig[index].hasError =
            value.trim() != "" && isValidEmail(value) ? false : true;
          columnConfig[index].errMsg = "";
          if (!Utility.isEmpty(value) && isValidEmail(value)) {
            setTimeout(() => {
              let params = {
                emailId: encodeURIComponent(value),
                userId: userId,
              };
              UserService.isEmailDuplicate(params).then((response) => {
                if (response && response["isdupliacateEmail"]) {
                  columnConfig = deepClone(detailsFormfields);
                  columnConfig[index].errMsg =
                    response.errCode === EMAIL_ERROR_CODE.EXIST_1002
                      ? "This email is already in use in another organization. Use the invite feature."
                      : "This email has already been taken.";
                  columnConfig[index].hasError = true;
                  setDetailsFormFields(columnConfig);
                }
              });
            }, 1000);
          }
          break;
        case COLUMN_CODES.CONTACT:
          if (!Utility.isEmpty(value) && Utility.isPhoneValid(value, getTenantCountryCode())) {
            columnConfig[index].errMsg = "Enter Valid Phone number.";
            columnConfig[index].hasError = true;
          }
          break;
        case "dateOfJoining":
          let dateOfJoining = moment(moment(value).format());
          let dateOfConfirmation = !Utility.isEmpty(
            defaultValues["dateOfConfirmation"]
          )
            ? moment(moment(defaultValues["dateOfConfirmation"]).format())
            : "";
          if (
            !isUSCountry &&
            (Utility.isEmpty(dateOfConfirmation) ||
              dateOfJoining.diff(dateOfConfirmation) <= 0)
          ) {
            columnConfig[index + 1].hasError = false;
            columnConfig[index + 1].errMsg = CONSTANTS.EMPTY_STRING;
          } else if (!isUSCountry) {
            columnConfig[index + 1].hasError = true;
            columnConfig[index + 1].errMsg = "DOC cannot be less than DOJ";
          }
          let dateOfBirth = moment(
            moment(defaultValues["dateOfBirth"]).format()
          );
          if (
            !Utility.isEmpty(dateOfBirth) &&
            moment(dateOfBirth).isSameOrAfter(dateOfJoining)
          ) {
            columnConfig[index].hasError = true;
            columnConfig[index].errMsg = `DOJ cannot be less than or equal to DOB`;
          } else {
            columnConfig[index].hasError = false;
            columnConfig[index].errMsg = `Enter a valid ${object.name}`;
            let columnIndex1 = columnConfig.findIndex(
              (x) => x.id === "dateOfBirth"
            );
            if (columnIndex1 != -1) {
              columnConfig[columnIndex1].hasError = false;
              columnConfig[columnIndex1].errMsg = `Enter a valid field value`;
            }
          }
          break;
        case "dateOfConfirmation":
          let doj = !Utility.isEmpty(defaultValues["dateOfJoining"])
            ? moment(moment(defaultValues["dateOfJoining"]).format())
            : "";
          let doc = moment(moment(value).format());
          if (Utility.isEmpty(doj) || doj.diff(doc) <= 0) {
            columnConfig[index].hasError = false;
            columnConfig[index].errMsg = CONSTANTS.EMPTY_STRING;
          } else {
            columnConfig[index].hasError = true;
            columnConfig[index].errMsg = "DOC cannot be less than DOJ";
          }
          break;
        case COLUMN_CODES.DATE_OF_BIRTH:
          let doj1 = moment(
            moment(defaultValues["dateOfJoining"]).format("YYYY-MM-DD")
          );
          let dob = moment(moment(value).format("YYYY-MM-DD"));
          if (customFieldSectionEnabled && moment().diff(dob, "years") < 18) {
            columnConfig[index].hasError = true;
            columnConfig[index].errMsg = `Employee must be at least 18 years old`;
          } else if (!Utility.isEmpty(doj1) && moment(dob).isSameOrAfter(doj1)) {
            columnConfig[index].hasError = true;
            columnConfig[index].errMsg = `DOB cannot be greater than or equal to DOJ`;
          } else {
            columnConfig[index].hasError = false;
            columnConfig[index].errMsg = `Enter a valid ${object.name}`;
            let columnIndex = columnConfig.findIndex(
              (x) => x.id === "dateOfJoining"
            );
            if (columnIndex != -1) {
              columnConfig[columnIndex].hasError = false;
              columnConfig[columnIndex].errMsg = `Enter a valid field value`;
            }
          }
          break;
        case COLUMN_CODES.PASSPORT_NUMBER:
          let columnIndex = columnConfig.findIndex(
            (x) => x.id === COLUMN_CODES.PASSPORT_COUNTRY
          );
          if (value.trim() == "") {
            columnConfig[columnIndex].required = false;
            columnConfig[columnIndex].hasError = false;
          } else {
            columnConfig[columnIndex].required = true;
            if (defaultValues[COLUMN_CODES.PASSPORT_COUNTRY] == "") {
              columnConfig[columnIndex].hasError = true;
            }
          }
          break;
        case COLUMN_CODES.PASSPORT_COUNTRY:
          if (Utility.isEmpty(defaultValues[COLUMN_CODES.PASSPORT_NUMBER])) {
            columnConfig[index].required = false;
            columnConfig[index].hasError = false;
          } else {
            columnConfig[index].required = true;
            if (value.length != 0) {
              columnConfig[index].hasError = false;
            } else {
              columnConfig[index].hasError = true;
            }
          }
          break;
        case 'employeeId':
            value = value.trim();
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                let empId = value;
                try {
                    empId = value.replace(/\s/g, '').trim();
                } catch {}
                checkCodeExist(columnConfig, empId, index);
            }, 100);
            break;
      }
      defaultValues[object.id] = value;
      setDetailsFormFields(columnConfig);
    } else if (Contact_Details.some((x) => x === object.id)) {
      let columnConfig = deepClone(contactFormfields);
      if (Utility.isEmpty(value) && object.required) {
        columnConfig[index].hasError = true;
      } else {
        switch (object.columnCode) {
          case "zipCode":
            columnConfig[index].hasError = isValidZipcode(
              value,
              COUNTRY_CODE.INDIA
            );
            break;

          default:
            columnConfig[index].hasError = false;
        }
      }
      columnConfig[index].value = value;
      defaultValues[object.id] = value;
      setContactFormFields(columnConfig);
    } else if (Compensation_Details.some((x) => x === object.id)) {
      let columnConfig = deepClone(compensationFormfields);
      if(object.id === "period") {
        defaultValues['effectivePeriod'] = value;
      }
      updateColumnStatus(object, columnConfig, value);
      index = columnConfig.findIndex(c => c.id === object.id)
      if (Utility.isEmpty(value) && object.required) {
        columnConfig[index].hasError = true;
        if (object.id === COLUMN_CODES.CTC && object.name === "CTC") {
            columnConfig[index].errMsg = `Enter a valid ${i18next.t("CTC")}`;
        }
      } else {
        let tenantData = TenantService.getData();
        switch (object.id) {
          case COLUMN_CODES.CTC:
          case COLUMN_CODES.DEFAULT_COMPENSATION:
            value = removeFirstDecimalFromInput(value);
            if (
              (isNaN(parseFloat(value)) && tenantData["CUSTOM_FIELD_SECTION_ENABLED"]) || (typeof parseFloat(value) === "number" &&
              Utility.isEmpty(parseFloat(value)) && !tenantData["CUSTOM_FIELD_SECTION_ENABLED"])
            ) {
              columnConfig[index].hasError = true;
            } else {
              columnConfig[index].hasError = false;
            }
            break;
          default:
            columnConfig[index].hasError = false;
        }
      }
      
      defaultValues[object.id] = value;
      setCompensationFormFields(columnConfig);
    } else if (Payment_Details.some((x) => x === object.id)) {
      let columnConfig = deepClone(paymentFormfields);
      if (object.id === "paymentMethod") {
        defaultValues[object.id] = value;
        updateColumConfigForPaymentMethod(value);
        buildPaymentDetails();
      } else if (Utility.isEmpty(value) && object.required) {
        columnConfig[index].hasError = true;
        columnConfig[index].errMsg = `Enter a valid ${object.name}`;
        defaultValues[object.id] = value;
        setPaymentFormFields(columnConfig);
      } else {
        switch (object.id) {
          case COLUMN_CODES.IFSC_CODE:
            const regexIFSC = new RegExp(IFSC_PATTERN);
            columnConfig[index].hasError = !regexIFSC.test(value);
            if (columnConfig[index].hasError) {
              columnConfig[index].errMsg = CONSTANTS.INVALID_IFSC;
            } else {
              columnConfig[index].errMsg = `Enter a valid ${object.name}`;
            }
            break;
          case COLUMN_CODES.ACCOUNT_NUMBER:
            let bank = (defaultValues.bank && defaultValues.bank.key) ?  defaultValues.bank.key : defaultValues.bank
            checkForAccountNumberIsValid(columnConfig, index, country, value, bank, object)
            break;
          case COLUMN_CODES.UPI_ID:
            const regexUPI = new RegExp(UPI_PATTERN);
            const upiRegexValue = !regexUPI.test(value);
            columnConfig[index].hasError = !regexUPI.test(value);
            if (!Utility.isEmpty(value) && upiRegexValue) {
              columnConfig[index].hasError = upiRegexValue;
              columnConfig[index].errMsg = CONSTANTS.INVALID_UPI;
            } else {
              columnConfig[index].hasError = false;
              columnConfig[index].errMsg = `Enter a valid ${object.name}`;
            }
            break;
          case COLUMN_CODES.ROUTING_NUMBER:
            let bankKey = isMYCompliance()? defaultValues['bank'].key:null
            checkRoutingNumberIsValid(columnConfig, index, country, value,bankKey , object);
            break;
          case COLUMN_CODES.BANK:
            if(value.key) {
              columnConfig[index].hasError = false;
              columnConfig[index].errMsg = `Enter a valid ${object.name}`;
              let routingNoIndex = columnConfig.findIndex(col=>col.columnCode=='routingNumber')
              let routingObj = columnConfig[routingNoIndex]
              checkRoutingNumberIsValid(columnConfig, routingNoIndex, country, defaultValues['routingNumber'], value.key, routingObj);
              
              let accountNoIndex = columnConfig.findIndex(col=>col.columnCode=='accountNumber')
              let accountObj = columnConfig[accountNoIndex]
              checkForAccountNumberIsValid(columnConfig,accountNoIndex,country,defaultValues['accountNumber'],value.key,accountObj)
            }
            break;
          default:
            columnConfig[index].hasError = false;
        }
        defaultValues[object.id] = value;
        setPaymentFormFields(columnConfig);
      }
    } else if (customFieldKeys.some((x) => x === object.id)) {
      let columnConfig = deepClone(customFormFields);
      if (Utility.isEmpty(value) && object.required) {
        columnConfig[index].hasError = true;
        columnConfig[index].errMsg = `Enter a valid ${object.name}`;
        defaultValues[object.id] = value;
        setCustomFormFields(columnConfig);
      } else {
        columnConfig[index].hasError = false;
        defaultValues[object.id] = value;
        isCustomFieldValid(value, object, columnConfig, index);
        setCustomFormFields(columnConfig);
      }
    } else if(object.id === 'ratePerHour') {
      let columnConfig = deepClone(billingFormFieldsInitials);
      if (Utility.isEmpty(value) && object.required) {
        columnConfig[index].hasError = true;
        columnConfig[index].errMsg = `Enter a valid ${object.name}`;
        defaultValues[object.id] = value.trim();
        setBillingFormFieldsInitials(columnConfig);
      } else {
        columnConfig[index].hasError = false;
        defaultValues[object.id] = value.trim();
        setBillingFormFieldsInitials(columnConfig);
      }
    } else if (object.id === 'hourlyWageDefaultHrs') {
      let columnConfig = deepClone(compensationFormfields);
      let idx = columnConfig.findIndex(col => col.columnCode === 'hourlyWageDefaultHrs')
      if (Utility.isEmpty(value) && object.required) {
        columnConfig[idx].hasError = true;
      } else {
        if (typeof value === "string" && (parseFloat(value) > 24 || parseFloat(value) === 0)) {
          columnConfig[idx].hasError = true;
        } else {
          columnConfig[idx].hasError = false;
        }
      }
      defaultValues[object.id] = value.trim();
      setCompensationFormFields(columnConfig);
    } else if (object.id === 'effectiveDefaultHrs') {
      let columnConfig = deepClone(compensationFormfields);
      let idx = columnConfig.findIndex(col => col.columnCode === 'effectiveDefaultHrs')
      if (Utility.isEmpty(value) && object.required) {
        columnConfig[idx].hasError = true;
      } else {
        if (typeof value === "string" && (parseFloat(value) > 24 || parseFloat(value) === 0)) {
          columnConfig[idx].hasError = true;
        } else {
          columnConfig[idx].hasError = false;
        }
      }
      defaultValues[object.id] = value.trim();
      setCompensationFormFields(columnConfig);
    }
    updatePropsValue();
    props.setUserDataUpdated(true);
  };

  const checkRoutingNumberIsValid = (columnConfig, index, country, value, bankKey, object) => {
    let regexStr = ROUTING_REGEX[country]?.regex
    if (isMYCompliance() && ROUTING_NUMBER_REGEX[country] && ROUTING_NUMBER_REGEX[country][bankKey]) {
      regexStr = ROUTING_NUMBER_REGEX[country][bankKey].regex 
      columnConfig[index].errMsg = `${object.name} should be ${ROUTING_NUMBER_REGEX[country][bankKey].errorMsg}` 
      let defaultValueConfig = isMYCompliance() ? DEFAULT_FIELD_VALUES[country][bankKey]: {};
      if(!Utility.isEmpty(defaultValueConfig?.fieldId)) {
        defaultValues[defaultValueConfig.fieldId] = defaultValueConfig?.defaultValue;
      }
    }
    const regex = new RegExp(regexStr);
    const routingRegexValue = !regex.test(value);
    if (!Utility.isEmpty(value) && routingRegexValue) {
      columnConfig[index].hasError = routingRegexValue;
      columnConfig[index].errMsg = ROUTING_REGEX[country]?.error || columnConfig[index].errMsg;
    } else {
      columnConfig[index].hasError = false;
      columnConfig[index].errMsg = `Enter a valid ${object.name}`;
    }
  }
  const checkForAccountNumberIsValid = (columnConfig,index,country,value,bankKey,object) => {
    if (columnConfig[index].required && !Utility.isEmpty(value)) {
      let validationConfig = isMYCompliance() ? ACCOUNT_NUMBER[country][bankKey]: ACCOUNT_NUMBER[country];
      if (validationConfig?.isRegex) {
        const regexAccountNumber = new RegExp(validationConfig.regexPattern);
        const accountNumberRegexValue = !regexAccountNumber.test(value);
        if (accountNumberRegexValue) {
          columnConfig[index].hasError = true;
          columnConfig[index].errMsg = `Enter a valid ${object.name}`;
        }
      } else if (validationConfig?.isMin && value.length < validationConfig?.minValue) {
        columnConfig[index].hasError = true;
        columnConfig[index].errMsg = !Utility.isEmpty(
          validationConfig?.minError
        ) ? validationConfig.minError : `Enter a valid ${object.name}`;
      } else if (validationConfig?.isMax && value.length > validationConfig?.maxValue) {
        columnConfig[index].hasError = true;
        columnConfig[index].errMsg = !Utility.isEmpty(
          validationConfig?.maxError
        )
          ? validationConfig.maxError
          : `Enter a valid ${object.name}`;
      } else {
        columnConfig[index].hasError = false;
        columnConfig[index].errMsg = `Enter a valid ${object.name}`;
      }
    } else if(columnConfig[index].required && Utility.isEmpty(value)) {
      columnConfig[index].hasError = true;
      columnConfig[index].errMsg = `Enter a valid ${object.name}`;
    } else {
      columnConfig[index].hasError = false;
      columnConfig[index].errMsg = `Enter a valid ${object.name}`;
     }
  }
  const checkCodeExist = (columnConfig, value, index) => {
    let oldValues = deepClone(employeeDetails)
    if(oldValues && oldValues.user  && oldValues.user.employeeId !== value && props.isEdit) {
      setTimeout(async () => {
        showLoader(i18next.t("VERIFY_EMPID"));
        const codeExists = await CustomNumberFormatService.checkNumberFormatExistance(value, CUSTOM_NUMBER_INPUT_MODULES.PEOPLE_EMPLOYEE);
        removeLoader();
        columnConfig = deepClone(detailsFormfields);
        if (codeExists?.status === 200) {
          columnConfig[index].hasError = false;
        } else if (codeExists?.status === 409) {
          columnConfig[index].errMsg =
            "This employee ID has already been used.";
          columnConfig[index].hasError = true;
          if (codeExists?.message && codeExists?.message?.toLowerCase() === EMPLOYEE_ID_EXIST) {
            showToast(i18next.t("EMPLOYEE_ID_EXIST"), TOAST_TYPE.WARNING);
          } else {
            showToast(codeExists?.message, TOAST_TYPE.WARNING);
          }
          setDetailsFormFields(columnConfig);
        }
      }, 0);
    } else if(oldValues && oldValues.user  && oldValues.user.employeeId !== value && props.isEdit) {
      columnConfig[index].hasError = false;
    }

  }
  const checkContactValidation = (columnConfig, value) => {
    let params = {
      contact: encodeURIComponent(`${getCountryPhoneCode()}${value}`),
      userId: userId
    };
    UserService.isContactDuplicate(params).then(
      (response) => {
        let columnData = deepClone(columnConfig);
        let config = columnData.find((x) => x.id === COLUMN_CODES.CONTACT);
        if (response) {
          if (!response["isdupliacateContact"]) {
            config.hasError = false;
            config.errMsg = "Enter Valid Phone number.";
          } else {
            config.hasError = true;
            config.errMsg = "This Phone number has already been taken.";
          }
        } else {
          config.hasError = false;
          config.errMsg = "Enter Valid Phone number.";
        }
        setDetailsFormFields(columnData);
      },
      (err) => {}
    );
  };

  const isCustomFieldValid = (value, object, columnConfig, index) => {
    if (object.type === INPUT_TYPE.TEXT && !Utility.isEmpty(object.maxLength)) {
      if (value && value.length > parseInt(object.maxLength)) {
        columnConfig[index].hasError = true;
        columnConfig[
          index
        ].errMsg = `Length should not exceed ${object.maxLength} characters`;
      } else {
        columnConfig[index].hasError = false;
        columnConfig[index].errMsg = `Enter a valid ${object.name}`;
      }
    } else if (
      object.type === INPUT_TYPE.NUMBER &&
      !Utility.isEmpty(object.decimalPrecision)
    ) {
      let decimalCount = getDecimalCount(value) || 0;
      if (decimalCount > parseInt(object.decimalPrecision)) {
        columnConfig[index].hasError = true;
        columnConfig[
          index
        ].errMsg = `Length should not exceed ${object.decimalPrecision} characters after decimal`;
      } else {
        columnConfig[index].hasError = false;
        columnConfig[index].errMsg = `Enter a valid ${object.name}`;
      }
    }
  };

  const getDecimalCount = (value) => {
    let enteredAmount = value;
    if (enteredAmount.split(".")[1] && enteredAmount.split(".")[1].length > 0) {
      return enteredAmount.split(".")[1].length;
    }
  };

  const updateColumConfigForPaymentMethod = (selectedOption, isInviteFlow) => {
    if (selectedOption && selectedOption.id === "cash") {
      const alteredConfig = [
        { columnCode: "accountType", required: false, uiVisible: false },
        { columnCode: "ifsc", uiVisible: false, required: false },
        { columnCode: "accountNumber", uiVisible: false, required: false },
        { columnCode: "routingNumber", required: false, uiVisible: false },
        { columnCode: "upiId", required: false, uiVisible: false },
        { columnCode: "bank", required: false, uiVisible: false },
      ];
      const updatedOptions = {
        accountType: [],
        ifsc: "",
        accountNumber: "",
        routingNumber: "",
        upiId: "",
        bank: ""
      };
      if (Utility.isEmpty(defaultValues["paymentMethod"]) && !isInviteFlow) {
        alteredConfig.push({ columnCode: "paymentMethod", hasError: true });
      } else {
        alteredConfig.push({ columnCode: "paymentMethod", hasError: false });
      }
      EmployeeListService.getAlteredConfigDetails(
        paymentInitials,
        alteredConfig,
        true,
        defaultValues,
        updatedOptions
      );
    } else if (selectedOption && selectedOption.id === "cheque") {
      const alteredConfig = [
        { columnCode: "accountType", required: false, uiVisible: false },
        {
          columnCode: "accountNumber",
          uiVisible: true,
          required: false,
          name: "Employee Bank Account Number",
        },
        { columnCode: "routingNumber", required: false, uiVisible: false },
        { columnCode: "upiId", required: false, uiVisible: false },
        { columnCode: "bank", required: false, uiVisible: false },
      ];
      const updatedOptions = {
        accountType: [],
        routingNumber: "",
        upiId: "",
        bank: "",
      };
      if (Utility.isEmpty(defaultValues["paymentMethod"]) && !isInviteFlow) {
        alteredConfig.push({ columnCode: "paymentMethod", hasError: true });
      } else {
        alteredConfig.push({ columnCode: "paymentMethod", hasError: false });
      }
      switch(country) {
        case "IN":
          alteredConfig.push({ columnCode: "ifsc", required: false, uiVisible:false });
          updatedOptions["ifsc"] = "";
          break;
      }
      EmployeeListService.getAlteredConfigDetails(
        paymentInitials,
        alteredConfig,
        true,
        defaultValues,
        updatedOptions
      );
    } else if (selectedOption && selectedOption.id === "upi") {
      const alteredOptions = [
        { columnCode: "accountType", required: false, uiVisible: false },
        { columnCode: "ifsc", required: false, uiVisible: false },
        { columnCode: "accountNumber", uiVisible: false, required: false},
        { columnCode: "routingNumber", required: false, uiVisible: false },
        { columnCode: "upiId", required: true, uiVisible: true, name: "UPI ID"},
        { columnCode: "bank", required: false, uiVisible: false },
      ];
      const updatedOptions = {
        accountType: [],
        ifsc:"",
        accountNumber:"",
        routingNumber: "",
        bank: "",
      };
      if (Utility.isEmpty(defaultValues["paymentMethod"]) && !isInviteFlow) {
        alteredOptions.push({ columnCode: "paymentMethod", hasError: true });
      } else {
        alteredOptions.push({ columnCode: "paymentMethod", hasError: false });
      }
      EmployeeListService.getAlteredConfigDetails(
        paymentInitials,
        alteredOptions,
        true,
        defaultValues,
        updatedOptions
      );
    } else {
      const updatedOptions = {
        upiId:""
      };
      const alteredConfig = [
        { columnCode: "upiId", required: false,uiVisible: false,name: "UPI ID"}
      ];
      switch(country) {
        case COUNTRY.US:
          alteredConfig.push({ columnCode: "accountType", required: true, uiVisible: true });
          alteredConfig.push({ columnCode: "accountNumber", uiVisible: true, required: true, name : "Account Number" });
          alteredConfig.push({ columnCode: "routingNumber", required: false, uiVisible: true });
          alteredConfig.push({ columnCode: "bank", required: false, uiVisible: false });
          alteredConfig.push({ columnCode: "ifsc", required: false, uiVisible: false });
          break;
        case COUNTRY.SG:
          alteredConfig.push({ columnCode: "accountType", required: false, uiVisible: false });
          alteredConfig.push({ columnCode: "accountNumber", uiVisible: true, required: true, name : "Account Number" });
          alteredConfig.push({ columnCode: "routingNumber", required: true, uiVisible: true, name: "Branch Code" });
          alteredConfig.push({ columnCode: "bank", required: true, uiVisible: true });
          alteredConfig.push({ columnCode: "ifsc", required: false, uiVisible: false });
          break;
        case COUNTRY.MY:
          alteredConfig.push({ columnCode: "accountType", required: false, uiVisible: false });
          alteredConfig.push({ columnCode: "accountNumber", uiVisible: true, required: true, name : "Account Number" });
          alteredConfig.push({ columnCode: "routingNumber", required: true, uiVisible: true, name: "Branch Code" });
          alteredConfig.push({ columnCode: "bank", required: true, uiVisible: true });
          alteredConfig.push({ columnCode: "ifsc", required: false, uiVisible: false });
          break;
        case COUNTRY.IN:
          alteredConfig.push({ columnCode: "accountType", required: true, uiVisible: true });
          alteredConfig.push({ columnCode: "accountNumber", uiVisible: true, required: true, name : "Employee Bank Account Number" });
          alteredConfig.push({ columnCode: "routingNumber", required: false, uiVisible: true });
          alteredConfig.push({ columnCode: "bank", required: false, uiVisible: false });
          alteredConfig.push({ columnCode: "ifsc", required: true, uiVisible: true, name: "IFSC Code" });
          break;
        default:
          alteredConfig.push({ columnCode: "accountType", required: true, uiVisible: true });
          alteredConfig.push({ columnCode: "accountNumber", uiVisible: true, required: true, name : "Account Number" });
          alteredConfig.push({ columnCode: "routingNumber", required: false, uiVisible: true });
          alteredConfig.push({ columnCode: "bank", required: false, uiVisible: false });
          alteredConfig.push({ columnCode: "ifsc", required: false, uiVisible: false });
          break;
      }
      if (Utility.isEmpty(defaultValues["paymentMethod"]) && !isInviteFlow) {
        alteredConfig.push({ columnCode: "paymentMethod", hasError: true });
      } else {
        alteredConfig.push({ columnCode: "paymentMethod", hasError: false });
      }
      EmployeeListService.getAlteredConfigDetails(
        paymentInitials,
        alteredConfig,
        true,
        defaultValues,
        updatedOptions
      );
    }
  };

  const updatePropsValue = (isAutoSave) => {
    props.setData({
      columnConfig: {
        detailsConfig: detailsFormfields,
        contactConfig: contactFormfields,
        compensationConfig: compensationFormfields,
        paymentConfig: paymentFormfields,
        customFields: customFormFields,
        billingFormFields: billingFormFieldsInitials,
        customSections: customSections
      },
      defaults: defaultValues,
      isAutoSave: isAutoSave,
      isInviteFlowEnabled: isAdmin
        ? isInviteUserEnabled
        : defaultValues["inviteUserToFillInfo"],
      employeeIdValid: employeeIdValid,
      employeeId:employeeId
    });
  };

  const getSelectLabel = (v, o) => {
    let value = v;

    const index = o.findIndex((i) => i.value === v);
    if (index !== -1) {
      value = o[index].label;
    }

    return value;
  };

  useEffect(() => {
    if (countryCode !== "-1") {
      const fields = EmployeeConfigService.getDefaultFieldsBySection(CONFIG_SECTION.ADDRESS);
      const contactFormfields = addCountrySpecificValidations(ADDRESS_MODULE.EMPLOYEE_DETAILS, countryCode, fields);

      if (props.isEditState && employeeDetails?.user?.address) {
        const address = employeeDetails.user.address;
        defaultValues["address"] = address;

        contactFormfields.forEach((field) => {
          if (field.type === INPUT_TYPE.DROPDOWN && field.id === "country") {
            let value = !Utility.isEmpty(address[field.id]) ? address[field.id] : countryCode;
            if (customFieldSectionEnabled && Utility.isEmpty(address[field.id])) {
              value = TenantService.get(TENANT.PW_REGION);
            }
            field.value = getSelectLabel(value, field.options);
          } else if (field.type === INPUT_TYPE.DROPDOWN) {
            field.value = getSelectLabel(address[field.id], field.options);
          } else {
            field.value = address[field.id];
          }
          field.validation = isInviteUserEnabled ? [] : field.validation;
        });
      } else {
        const address = {};
        let country = countryCode;
        if (customFieldSectionEnabled) {
          country = TenantService.get(TENANT.PW_REGION);
        }
        contactFormfields.forEach((field) => {
          if (field.id === "country") {
            field.value = getSelectLabel(country, field.options);
            address[field.id] = country;
          } else {
            address[field.id] = "";
          }
          field.validation = isInviteUserEnabled ? [] : field.validation;
        });
        defaultValues["address"] = address;
      }

      setContactFormFields(contactFormfields);
    }
  }, [countryCode, isInviteUserEnabled]);

  const getSelectValue = (v, o) => {
    let value = v;

    const index = o.findIndex((i) => i.label === v);
    if (index !== -1) {
      value = o[index].value;
    }

    return value;
  };

  const onPaymentExpandCollapse = (value) => {
    setPaymentDetailsExpanded(value);
  };

  const onContactExpandCollapse = (value) => {
    setContactDetailsExpanded(value);
  };

  const onInviteCheck = (value, obj, index) => {
    defaultValues[obj.id] = value;
    setPaymentDetailsExpanded(!value);
    setContactDetailsExpanded(!value);
    setInviteUser(value);
  };

  const updateLocationButtonConfig = (columnConfig) => {
    const buttonConfig = {
      title: `+ Add a location`,
      onClick: () => {
        onAddLocation();
      },
      className: "bg-app text-white",
    };
    const index = columnConfig.findIndex(
      (c) => c.columnCode === COLUMN_CODES.LOCATION_VALUE
    );
    if (index != -1) {
      columnConfig[index].button = buttonConfig;
    }

    return columnConfig;
  };

  const onClose = () => {
    setAllowLocationAdd(false);
  };

  const onAddLocation = () => {
    setAllowLocationAdd(true);
  };

  const selectedFormat = (selected) => {
    let updatedState = employeeId;
    if(selected && selected.manualMode) {
      defaultValues["documentSequenceId"] = '';//selected.id ? selected.id:(selected.text ? selected.text:(selected.sequenceObj ? selected.sequenceObj.id : ""));
      defaultValues["employeeId"] = selected.id ? selected.id:(selected.text ? selected.text:(selected.sequenceObj ? selected.sequenceObj.id : ""));
      setEmployeeIdValid(!Utility.isEmpty(selected.text))
    } else {
      defaultValues["documentSequenceId"] = selected.id ? selected.id:(selected.text ? selected.text:(selected.sequenceObj ? selected.sequenceObj.id : ""));
      defaultValues["employeeId"] = '';//selected.id ? selected.id:(selected.text ? selected.text:(selected.sequenceObj ? selected.sequenceObj.id : ""));
      setEmployeeIdValid(true);
    }

    updatedState = selected.id ? selected.id:(selected.text ? selected.text:(selected.sequenceObj ? selected.sequenceObj.id : ""));

    setEmployeeId(updatedState);
  };

  const employeeIdValidFun = (data) => {
    setEmployeeIdValid(data)
  }

  const getFormatDetails = () =>{
    return(
      <div className="mt-s mb-r parent-width">
          <CustomNumberFormatInput
            module={CUSTOM_NUMBER_INPUT_MODULES.PEOPLE_EMPLOYEE}
            selectedFormat={selectedFormat}
            extraClass={'mt-s top-10 right-1'}
            isRow={false}
            employeeIdValid={employeeIdValidFun}
          />
      </div>
    );
  };

  const renderDetailsFormFields = (field, index) => {
		return (
      <>
        {field.type != INPUT_TYPE.CHECKBOX && (
          <div
						key={field.id}
            className={`column p-h-l padding-bottom-mobile web-width-50 ${field.columnCode} ${
							field.hasError && (defaultValues[field.id] == '' || field.columnCode == 'emailId') ? 'mb-l' : 'mb-l'
						}`}
          >
            <DKInput
              ref={!isAdmin ? ERF.ADD_EMPLOYEE[field.id] : isAdmin && props.isEdit ? ARF.ADD_EMPLOYEE[field.id] : null}
              title={field.name}
              placeholder={field.name}
              value={defaultValues[field.id]}
              formatter={(obj) => {
                return obj.name;
              }}
              options={field.options}
              type={field.type}
              labelClassName=" text-align-left "
              onChange={(value) => {
                onChange(value, index, field, field.name);
              }}
              direction={field.direction}
              required={field.required}
              readOnly={field.readOnly || !hasPermission}
              canValidate={field.hasError}
              onClick={() => {
                if (index === detailsFormfields.length - 1) {
                  scrollToBottom();
                }
              }}
              dropdownConfig={{
                className: '',
                style: {},
                allowSearch: field.options && field.options.length > 6 ? true : false,
                searchableKey: 'name',
                data: field.options,
                renderer: (idx, obj) => {
                  return <DKLabel text={`${obj.name}`} />;
                },
                onSelect: () => {},
                button: field.button,
              }}
              tooltip={{
                content: field.tooltipText,
                className: 'warning-tooltip-prop',
              }}
              validator={(value) => {
                return !field.hasError;
              }}
              errorMessage={field.errMsg}
            />
            {!field.required && field.hasError && field.columnCode !== 'contact' && (
              <DKLabel
                className="mt-s pl-s fs-s unselectable text-red"
                style={{
                  whiteSpace: 'nowrap',
                }}
                text={field.errMsg}
              />
            )}
          </div>
        )}
        {field.type === INPUT_TYPE.CHECKBOX && (
          <div
            className="row p-h-l p-v-l"
            style={{
              width: `${field.width ? `${field.width}%` : '50%'}`,
              pointerEvents: `${
                (!isAdmin && DataGridUtility.checkIsFieldReadOnly(field.columnCode, false)) || !hasPermission ? 'none' : ''
              }`,
            }}
            key={field.id}
          >
            <div onClick={() => onInviteCheck(!isInviteUserEnabled, field, index)}>
              <DKCheckMark
                isSelected={!props.isEdit ? isInviteUserEnabled : defaultValues[field.id]}
                color="bg-app"
                disabled={field.readOnly}
              />
            </div>
            <DKLabel className="ml-s" text={field.name} />
            {field.hasTooltip && field.tooltipText != '' && (
              <DKTooltipWrapper content={field.tooltipText} tooltipClassName="warning-tooltip-prop ">
                <DKIcon src={ic_info_message} className="ml-s ic-s ml-r mt-xs cursor-hand " style={{ opacity: 0.4 }} />
              </DKTooltipWrapper>
            )}
          </div>
        )}
      </>
    );
  };

  const getDetailsFormFields = () => {
    const fieldsToRender = [];
    if (Array.isArray(EmployeeConfigService.EMPLOYEE_CONFIG_BY_SECTION[CONFIG_SECTION.EMPLOYEE_DETAILS])) {
      const section = EmployeeConfigService.getNonDefaultSectionsByName(
        customSections,
        CONFIG_SECTION.EMPLOYEE_DETAILS,
        hasPermission,
        pwRole
      );

      EmployeeConfigService.EMPLOYEE_CONFIG_BY_SECTION[CONFIG_SECTION.EMPLOYEE_DETAILS].map((field) => {
        if (!field.systemField) {
          const index = section.fields.findIndex((f) => f.id === field.id);
          fieldsToRender.push(renderCustomSectionField(section.fields[index], section));
        } else {
					const index = detailsFormfields.findIndex((f) => f.id === field.id && !(f.id === 'employeeId' && !props.isEdit && !props.isEditState));
					if (index !== -1) {
						fieldsToRender.push(renderDetailsFormFields(detailsFormfields[index], index));
					}
        }
      });
    }

    return fieldsToRender;
  };

  const getCompensationFormFields = () => {
    const filtered = compensationFormfields.filter(x => x.uiVisible)
    return filtered.map((obj, index) => {
        switch (obj.id) {
            case "ctc":
            case "defaultCompensation":
                return (
                    <div
                      className={`column p-h-l ${obj.width ? "":"web-mr-l"} ${obj.columnCode}`}
                      style={{
                        width: `${
                          viewportLarge ? (obj.width ? `${obj.width}%` : "50%") : "100%"
                        }`,

                      }}
                      key={obj.id}
                    >
                      <div
                        className="row-responsive padding-bottom-mobile"
                        style={{
                          width: `${obj.subWidth ? `${obj.subWidth}%` : "100%"}`,

                        }}
                      >
                        <MaskInput
                            setRef={(ref) => ERF.ADD_EMPLOYEE[obj.id] = ref}
                            showMask={mask}
                            unmaskLen={0}
                            className={`pt-s`}
                            title={i18next.t(obj.name)}
                            placeholder={i18next.t(obj.name)}
                            direction={obj.direction}
                            type={obj.type}
                            value={PermissionUtils.showMaskedAmount(defaultValues[obj.id], selfView)}
                            readOnly={obj.readOnly || !PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT)}
                            required={obj.required && isAdmin && PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT)}
                            canValidate={false}
                            onChange={(value) => {
                                onChange(value, index, obj, obj.name);
                            }}
                            invalid={obj.hasError}
                            errorMessage={obj.errMsg}
                        />
                        {/* {obj.hasError && (
                          <DKLabel
                            className="pl-s fs-s unselectable text-red mt-s"
                            style={{
                              whiteSpace: "nowrap",
                            }}
                            text={obj.errMsg}
                          />
                        )} */}
                      </div>
                    </div>
                  );
            default:
                return (
                  <div
                    className={`column p-h-l ${obj.width ? "":"web-mr-l mb-r"} ${obj.columnCode} `}
                    style={{
                      width: `${
                        viewportLarge ? (obj.width ? `${obj.width}%` : "50%") : "100%"
                      }`,

                    }}
                    key={obj.id}
                  >
                    <div
                      className="row-responsive padding-bottom-mobile"
                      style={{
                        width: `${obj.subWidth ? `${obj.subWidth}%` : "100%"}`,

                      }}
                    >
                      {obj.type === "toggle" && (
                        <div
                          className="d-flex align-items-center mb-s"
                          style={{ pointerEvents: (isAdmin) && PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT) ? "" : "none" }}
                        >
                          <Toggle
                            className="border-n"
                            isOn={defaultValues["isEffectiveSalary"]}
                            onChange={() => setEffectiveToggle()}
                          />
                          <DKLabel className="ml-m" text={obj.name} />
                        </div>
                      )}
                      {obj.type != "toggle" && (
                        <DKInput
                          className={`pt-s`}
                          title={`${obj.name}`}
                          placeholder={obj.name}
                          value={defaultValues[obj.id]}
                          formatter={(obj) => {
                            /** How to render a selected option in case of object **/
                            return obj.name;
                          }}
                          options={obj.options}
                          type={obj.type}
                          labelClassName=" text-align-left "
                          onChange={(value) => {
                            onChange(value, index, obj, obj.name);
                          }}
                          direction={obj.direction}
                          required={obj.required && PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT)}
                          readOnly={obj.readOnly || !PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT) 
                            || !hasPermission}
                          onClick={() => {
                            if (index === contactFormfields.length - 1) {
                              scrollToBottom();
                            }
                          }}
                          dropdownConfig={{
                            className: "",
                            style: {},
                            allowSearch:
                              obj.options && obj.options.length > 6 ? true : false,
                            searchableKey: "name",
                            data: obj.options,
                            renderer: (index, obj) => {
                              /** How to render value in Dropdown in case of object **/
                              return <DKLabel text={`${obj.name}`} />;
                            },
                            onSelect: (index, obj) => {
                              // onValueChange(obj, "Quarter");
                            },
                          }}
                          canValidate={obj.hasError && PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT)}
                          validator={(value) => {
                            return !obj.hasError && PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT);
                          }}
                          errorMessage={obj.errMsg}
                        />
                      )}
                      {/* {obj.hasError && (
                        <DKLabel
                          className="pl-s fs-s unselectable text-red mt-s"
                          style={{
                            whiteSpace: "nowrap",
                          }}
                          text={obj.errMsg}
                        />
                      )} */}
                    </div>
                  </div>
                );
        }
    });
  };

const getBillableFields = () => {
  return billingFormFieldsInitials.map((obj, index) => {
    return (
      <div
        className={`column p-h-l web-width-50 mb-s padding-bottom-mobile ${obj.columnCode}`}
        key={obj.id}
      >
        <DKInput
          title={obj.name}
          placeholder={obj.name}
          value={defaultValues[obj.id]}
          className=''
          formatter={(obj) => {
            /** How to render selected value from strig of Array */
            return obj;
          }}
          options={obj.options}
          type={obj.type}
          labelClassName=" text-align-left "
          onChange={(value) => {
            onChange(value, index, obj, obj.name);
          }}
          direction={obj.direction}
          required={obj.required}
          readOnly={obj.readOnly || !hasPermission}
          canValidate={obj.hasError}
          onClick={() => {
          }}
          validator={(value) => {
            return !obj.hasError;
          }}
          dropdownConfig={{
            className: "",
            style: {},
            allowSearch: obj.options && obj.options.length > 6 ? true : false,
            searchableKey: undefined,
            data: obj.options,
            renderer: (index, obj) => {
              /*How to render dropdwon options from string of array*/
              return <DKLabel className="" text={obj} />;
            },
            onSelect: (index, value) => {},
          }}
        />
      </div>
    );
  });
};
const getTDSFields = () => {
  
  let isValidMonth = false;
  return (
    <div className="row row-responsive">
      <div
        className={`d-flex p-h-l web-width-50 mb-s padding-bottom-mobile `}
        key={'year_TDS'}
      >
        <DKInput
          title={'Year'}
          placeholder={'Year'}
          value={valueTDS.year}
          className='mr-m'
          formatter={(obj) => {
            /** How to render selected value from strig of Array */
            return obj;
          }}
          options={[moment().year(), moment().subtract(1, 'years').year()]}
          type={INPUT_TYPE.DROPDOWN}
          labelClassName=" text-align-left "
          onChange={(value) => {
            setValueTDS({
              ...valueTDS,
              year:value
            });
          }}
          direction={INPUT_VIEW_DIRECTION.VERTICAL}
          required={true}
          readOnly={false || !hasPermission}
          canValidate={true}
          onClick={() => {
          }}
          validator={(value) => {
            return true;
          }}
          dropdownConfig={{
            className: "",
            style: {},
            allowSearch: false,
            searchableKey: '',
            data: [moment().year(), moment().subtract(1, 'years').year()],
            renderer: (index, obj) => {
              /*How to render dropdwon options from string of array*/
              return <DKLabel className="" text={obj} />;
            },
            onSelect: (index, value) => { },
          }}
        />
        <DKInput
          title={'Month'}
          placeholder={'Month'}
          value={valueTDS.month}
          className=''
          formatter={(obj) => {
            /** How to render selected value from strig of Array */
            return obj.label;
          }}
          options={FINANCIAL_MONTHS}
          type={INPUT_TYPE.DROPDOWN}
          labelClassName=" text-align-left "
          onChange={(value) => {
            setValueTDS({
              ...valueTDS,
              month:value
            });
          }}
          direction={INPUT_VIEW_DIRECTION.VERTICAL}
          required={true}
          readOnly={false || !hasPermission}
          canValidate={true}
          onClick={() => {
          }}
          validator={(value) => {
            //note: will use later:- For now remove validation for Future Month.
            // let selectedDate = `${valueTDS.year}-${value.value<10?"0":""}${value.value}-01`
            // let currentDate = moment().format("YYYY-MM-01");
            // let hasError = moment(moment(currentDate),"YYYY-MM-DD").isSameOrAfter(moment(selectedDate,"YYYY-MM-DD"));
            // return hasError;
            return true
          }}
          dropdownConfig={{
            className: "",
            style: {},
            allowSearch: true,
            searchableKey: 'label',
            data: FINANCIAL_MONTHS,
            renderer: (index, obj) => {
              /*How to render dropdwon options from string of array*/
              return <DKLabel className="" text={obj.label} />;
            },
            onSelect: (index, value) => { },
          }}
        />
      </div>
      <div
        className={`column p-h-l web-width-50 mb-s padding-bottom-mobile `}
        key={'month'}
      >
        <DKButton 
          title={"Download TDS Report"}
          className="border-m bg-gray1 mt-l"
          icon={DKIcons.ic_download}
          onClick={() => {
            if(isValidMonth) {
            showToast('Future month not allowed.', TOAST_TYPE.FAILURE)
              return
            }
            setDownloadTDS(true);
            let param = {
              month:valueTDS.month.value,
              year:valueTDS.year, 
              userId: userId
            }
            ReportService.downloadTDS(param).then(response=>{
              setDownloadTDS(false);
              saveAs(response, `TDS_Report_${valueTDS.month.label}_${valueTDS.year}.pdf`);
              showToast('TDS Report Downloaded successfully.', TOAST_TYPE.SUCCESS)
            },error=>{
              setDownloadTDS(false);
              showAlert('No data found','No TDS report data found for selected month and year.');
            })
            
          }
          } 
        />
      </div>
    </div>
  );
}
  const getPaymentFormFields = () => {
    return paymentFormfields.map((obj, index) => {
      return (
        <div
          className={`column p-h-l pb-s mb-m web-width-50 padding-bottom-mobile ${obj.columnCode}`}

          key={obj.id}
        >
          <DKInput
            ref={ERF.ADD_EMPLOYEE[obj.id]}
            title={obj.name}
            placeholder={obj.name}
            value={defaultValues[obj.id]}
            formatter={(obj) => {
              /** How to render a selected option in case of object **/
              return obj.name;
            }}
            options={obj.options}
            type={obj.type}
            labelClassName=" text-align-left "
            onChange={(value) => {
              onChange(value, index, obj, obj.name);
            }}
            direction={obj.direction}
            required={obj.required}
            readOnly={obj.readOnly || !hasPermission}
            onClick={() => {
              if (index === contactFormfields.length - 1) {
                scrollToBottom();
              }
            }}
            dropdownConfig={{
              className: "",
              style: {},
              allowSearch: obj.options && obj.options.length > 6 ? true : false,
              searchableKey: "name",
              data: obj.options,
              renderer: (index, obj) => {
                /** How to render value in Dropdown in case of object **/
                return <DKLabel text={`${obj.name}`} />;
              },
              onSelect: (index, obj) => {
                // onValueChange(obj, "Quarter");
              },
            }}
            canValidate={obj.hasError}
            validator={(value) => {
              return !obj.hasError;
            }}
            errorMessage={obj.errMsg}
          />
          {/* {obj.hasError && (
            <DKLabel
              className="pl-s fs-s unselectable text-red mt-r"
              style={{
                whiteSpace: "nowrap",
              }}
              text={obj.errMsg}
            />
          )} */}
        </div>
      );
    });
  };

  const getCustomFormFields = () => {
    return customFormFields.map((obj, index) => {
      return (
        <div
          className={`column p-h-l web-width-50 mb-s padding-bottom-mobile ${obj.columnCode}`}
          key={obj.id}
        >
          <DKInput
            title={obj.name}
            placeholder={obj.name}
            value={defaultValues[obj.id]}
            className=''
            formatter={(obj) => {
              /** How to render selected value from strig of Array */
              return obj;
            }}
            options={obj.options}
            type={obj.type}
            labelClassName=" text-align-left "
            onChange={(value) => {
              onChange(value, index, obj, obj.name);
            }}
            direction={obj.direction}
            required={obj.required}
            readOnly={obj.readOnly || !hasPermission}
            canValidate={false}
            onClick={() => {
              if (index === contactFormfields.length - 1) {
                scrollToBottom();
              }
            }}
            dropdownConfig={{
              className: "",
              style: {},
              allowSearch: obj.options && obj.options.length > 6 ? true : false,
              searchableKey: undefined,
              data: obj.options,
              renderer: (index, obj) => {
                /*How to render dropdwon options from string of array*/
                return <DKLabel className="" text={obj} />;
              },
              onSelect: (index, value) => {},
            }}
          />
          {obj.hasError && (
            <DKLabel
              className="pl-s fs-s unselectable text-red"
              style={{
                whiteSpace: "nowrap",
              }}
              text={obj.errMsg}
            />
          )}
        </div>
      );
    });
  };

  const updateField = (fieldToUpdate, section) => {
      const sectionToUpdate = { ...section };
      const fieldsToUpdate = [...sectionToUpdate.fields];
      const idx = fieldsToUpdate.findIndex((f) => f.id === fieldToUpdate.id);
      if (idx !== -1) {
          fieldsToUpdate[idx] = fieldToUpdate;
      }

      sectionToUpdate.fields = fieldsToUpdate;
      updateSection(sectionToUpdate);
  };

  const updateSection = (sectionToUpdate) => {
    const customSectionsToUpdate = [...customSections];
    const idx = customSectionsToUpdate.findIndex((s) => s.name === sectionToUpdate.name);
    if (idx !== -1) {
      customSectionsToUpdate[idx] = sectionToUpdate;
    }

    defaultValues["customSectionFields"] = CustomSectionManager.getCustomSectionFields(customSectionsToUpdate);
    setCustomSections(customSectionsToUpdate);
  }

  const updateSectionExpanded = (sectionName, isExpanded) => {
    const customSectionsToUpdate = [...customSections];
    customSectionsToUpdate.forEach((section) => {
      if (section.name === sectionName) {
        section.isExpanded = isExpanded;
      }
    });
    setCustomSections(customSectionsToUpdate);
  }

  const getEmployeeTaxes = () => {
    return employeeTaxes.map((obj, index) => {
      return (
        <>
          <tr className="p-v-s">
            <td className="p-v-s">
              <div
                className="d-flex bg-gray2 ellipsis"
                style={{
                  height: "30px",
                  alignItems: "center",
                  borderRadius: "10px",
                  width: "max-content",
                }}
              >
                <span className="p-l fw-r ellipsis">{obj.name}</span>
              </div>
            </td>
            <td className="p-v-s">
              {obj.applicable && (
                <div className="d-flex pl-l">
                  <DKStatus color="bg-green" />
                  <div className="fw-m">Applicable</div>
                </div>
              )}
              {!obj.applicable && (
                <div className="d-flex pl-l">
                  <DKStatus color="bg-gray" />
                  <div className="fw-m">Not Applicable</div>
                </div>
              )}
            </td>
          </tr>
        </>
      );
    });
  };

  const renderCustomSectionField = (field, section) => {
    return (
      <CustomSectionField
        field={field}
        updateField={(fieldToUpdate) => {
          updateField(fieldToUpdate, section);
        }}
      />
    );
  }

  const getNonDefaultSectionsByName = (sectionName) => {
    const section = EmployeeConfigService.getNonDefaultSectionsByName(customSections, sectionName, hasPermission, pwRole);
    return (
      <Fragment>
          {section?.fields?.length > 0 && (
            <div className="parent-width">
              <DKLine className="mt-m mb-r bg-line-2" />
              <div className="parent-width parent-width pt-s" style={{ display: "flex", flexWrap: "wrap" }}>
                <EmployeeCustomSection
                  section={section}
                  updateSection={(sectionToUpdate) => {
                    updateSection(sectionToUpdate);
                  }}
                />
              </div>
            </div>
          )}
      </Fragment>
    );
  }

  return (
    <>
      <div className="row-responsive d-flex ">
        <div className="web-width-70 mb-l">
          <div className="mt-m parent-width bg-white border-radius-s card-shadow">
            <div className="row justify-content-between p-h-l pt-l pb-m">
                <DKLabel
                    text="Employee Details"
                    className="fw-m fs-l"
                />
            </div>
            <DKLine className="bg-line-2" />
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
              }}
              className={` parent-width mt-s ${isUSCountry ? "" : "pb-m"} `}
            >
              {(!props.isEdit && !props.isEditState) && getFormatDetails()}
              {detailsFormfields && getDetailsFormFields()}
            </div>
          </div>
          {contactFormfields && (
            <div className="mt-xl parent-width bg-white border-radius-s card-shadow">
              <DKExpandableWrapper
                title="Contact Details"
                className="collapsable"
                expanded={isContactDetailsExpanded}
                headerStyle={{ padding: "18px 18px 14px 18px" }}
                onClick={(expanded) => {
                  onContactExpandCollapse(expanded);
                }}
              >
                <DKLine className="bg-line-2 mb-m" />
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                  className=" parent-width mb-s pb-s pt-xs"
                >
                  {contactFormfields && (
                    <Address
                      className="pb-s"
                      countryCode={countryCode}
                      addressFields={contactFormfields}
                      module={ADDRESS_MODULE.EMPLOYEE_DETAILS}
                      isReadOnly={!hasPermission}
                      onChange={(contactFormfields) => {
                        setContactFormFields(contactFormfields);
                        const address = {};
                        contactFormfields.forEach((field) => {
                          if (field.type === INPUT_TYPE.DROPDOWN) {
                            address[field.id] = getSelectValue(
                              field.value,
                              field.options
                            );
                          } else {
                            address[field.id] = field.value;
                          }
                        });
                        defaultValues["address"] = address;
                        props.setUserDataUpdated(true);
                      }}
                    />
                  )}
                  {Array.isArray(customSections) && getNonDefaultSectionsByName(CONFIG_SECTION.ADDRESS)}
                </div>
              </DKExpandableWrapper>
            </div>
          )}
          {compensationFormfields && !hideCompensation && (!isAdmin || PermissionUtils.hasAccess(MODULE.SALARY, [ACTION.VIEW, ACTION.EDIT]) || selfView) && (
            <div className="mt-xl parent-width bg-white border-radius-s card-shadow">
              <DKExpandableWrapper
                title="Compensation Details"
                className="collapsable"
                expanded={isCompensationDetailsExpanded}
                headerStyle={{ padding: "18px 18px 14px 18px" }}
                onClick={(expanded) => {
                  setCompensationDetailsExpanded(expanded);
                }}
              >
                <DKLine className="bg-line-2" />
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                  className="parent-width mb-s pb-s pt-l"
                >
                  <div className="parent-width mb-m" style={{ display: "flex", flexWrap: "wrap" }}>
                    {compensationFormfields && getCompensationFormFields()}
                  </div>
                  {Array.isArray(customSections) && getNonDefaultSectionsByName(CONFIG_SECTION.COMPENSATION)}
                </div>
              </DKExpandableWrapper>
            </div>
          )}
          {paymentFormfields && (
            <div className="mt-xl parent-width bg-white border-radius-s card-shadow">
              <DKExpandableWrapper
                id="1"
                title="Payment Details"
                className="collapsable"
                expanded={isPaymentDetailsExpanded}
                headerStyle={{ padding: "18px 18px 14px 18px" }}
                onClick={(expanded) => {
                  onPaymentExpandCollapse(expanded);
                }}
              >
                <DKLine className="bg-line-2 mb-m" />
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                  className=" parent-width mb-s pb-m pt-s"
                >
                  {paymentFormfields && getPaymentFormFields()}
                  {Array.isArray(customSections) && getNonDefaultSectionsByName(CONFIG_SECTION.EMPLOYEE_PAYMENT_DETAILS)}
                </div>
              </DKExpandableWrapper>
            </div>
          )}
          {billingFormFieldsInitials && (
            <div className="mt-xl parent-width bg-white border-radius-s card-shadow">
              <DKExpandableWrapper
                title="Biling Rate"
                className="collapsable"
                expanded={isBillingRateExpanded}
                headerStyle={{ padding: "18px 18px 14px 18px" }}
                onClick={(expanded) => {
                  setBillingRateExpanded(expanded);
                }}
              >
                <DKLine className="bg-line-2" />
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                  className=" parent-width mb-s p-v-l"
                >
                  {billingFormFieldsInitials && getBillableFields()}
                  {Array.isArray(customSections) && getNonDefaultSectionsByName(CONFIG_SECTION.BILLING_RATE)}
                </div>
              </DKExpandableWrapper>
            </div>
          )}
          {customFormFields && customFormFields.length > 0 && (
            <div className="mt-xl parent-width bg-white border-radius-s card-shadow">
              <DKLabel
                text="Custom Fields"
                className="fw-m fs-l mb-m pt-l p-h-l"
              />
              <DKLine className="bg-line-2" />
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                }}
                className=" parent-width parent-width pb-xl pt-s"
              >
                {customFormFields && getCustomFormFields()}
              </div>
            </div>
          )}
          {Array.isArray(customSections) && (
            <Fragment>
              {EmployeeConfigService.getNonDefaultSections(customSections, hasPermission, pwRole).map((section) => {
                return (
                  <div className="mt-xl parent-width bg-white border-radius-s card-shadow">
                    <DKExpandableWrapper
                      title={section.title}
                      className="collapsable"
                      expanded={section.isExpanded}
                      headerStyle={{ padding: "18px 18px 14px 18px" }}
                      onClick={(isExpanded) => {
                        updateSectionExpanded(section.name, isExpanded);
                      }}
                    >
                      <DKLine className="bg-line-2" />
                      <div className="parent-width parent-width pb-m pt-s" style={{ display: "flex", flexWrap: "wrap" }}>
                        <EmployeeCustomSection
                          section={section}
                          updateSection={(sectionToUpdate) => {
                            updateSection(sectionToUpdate);
                          }}
                        />
                      </div>
                    </DKExpandableWrapper>
                  </div>
                )
              })}
            </Fragment>
          )}
          {terminationDetailSection &&
            <div className="mt-xl parent-width bg-white border-radius-s card-shadow">
              <DKExpandableWrapper
                title={terminationDetailSection.title}
                className="collapsable"
                expanded={terminationDetailSection.isExpanded}
                headerStyle={{ padding: "18px 18px 14px 18px" }}
                onClick={(isExpanded) => {
                  setTerminationDetailSection({
                    ...terminationDetailSection,
                    isExpanded: isExpanded
                  });
                }}
              >
                <DKLine className="bg-line-2" />
                <div className="parent-width parent-width pb-m pt-s" style={{ display: "flex", flexWrap: "wrap" }}>
                  <EmployeeCustomSection
                    section={terminationDetailSection}
                    updateSection={() => {}}
                  />
                </div>
              </DKExpandableWrapper>
            </div>
          }
          {(props.isEdit && !isMobileWebView() && isIndiaCompliance()) && (
            <div className="mt-xl parent-width bg-white border-radius-s card-shadow">
              <div className="d-flex">
              <DKLabel
                text="TDS Report"
                className="fw-m fs-l mb-m pt-l p-h-l"
              />
              {isDownloadingTDS&&<DKSpinner/>}
              
              </div>
              <DKLine className="bg-line-2" />
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                }}
                className=" row row-responsive mb-s p-v-l"
              >
                {(props.isEdit && isAdmin) && getTDSFields()}
              </div>
            </div>
          )}
          {isIndiaCompliance() &&
            userId &&
            employeeTaxes &&
            employeeDetails?.user?.status !== CONSTANTS.DRAFT && (
              <div className="mt-xl parent-width bg-white border-radius-s card-shadow">
                <DKLabel
                  text="Taxes Applicable"
                  className="fw-m fs-l mb-r pt-l p-h-l"
                />
                <DKLine className="bg-line-2" />
                {!isTaxesSpinner && (
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                    }}
                    className=" parent-width mb-s "
                  >
                    <div className="p-v-s p-h-l" style={{ width: "100%" }}>
                      {employeeTaxes && <table>{getEmployeeTaxes()}</table>}
                    </div>
                  </div>
                )}
                {isTaxesSpinner && <DKSpinner className="pt-xxl pb-xxl" />}
                {!isTaxesSpinner && employeeTaxes.length === 0 && (
                  <>
                    <div className="row justify-content-center">
                      <div>
                        <img src={zeroState} className="ic-xl" />
                      </div>
                    </div>
                    <div className="pb-l">
                      <div className="fs-r fw-m">No Taxes Found</div>
                    </div>
                  </>
                )}
              </div>
            )}
        </div>
        <div className="pt-l pl-l web-width-30 padding-empty-mobile">
          {!hideCompensation && <RightPanel data={deepClone(defaultValues)} stage={0} mask={mask} userId={userId} />}
        </div>
      </div>
      {allowLocationAdd && (
        <AddEditLocation
          {...props}
          isEdit={false}
          data={{}}
          onClose={() => onClose()}
        />
      )}
    </>
  );
});

export default EmployeeDetails;
